<template>
  <div style="margin-bottom: 15px">
    <nav-menu></nav-menu>
 
    <div class="w3-row w3-container">
      <div class="w3-block w3-text-theme w3-margin-top">
        <h3><i class="fas fa-chart-line"></i> Aferição do Lucro</h3>
      </div>
    </div>

    <div class="w3-row w3-container" style="margin-bottom: 5px" v-cloak>
      <button 
        class="w3-button w3-theme margin-top10" 
        @click="mostrarModalConfiguracoesIniciais()"
        v-if="(!temResultado) && (!processando)">
        <i class="fa fa-cog"></i> Filtros iniciais
      </button>

      <button 
        class="w3-button w3-theme margin-top10" 
        @click="mostrarModalConfiguracoesContas()"
        v-if="temResultado">
        <i class="fa fa-cog"></i> Contas
      </button>

      <button 
        class="w3-button w3-theme margin-top10"
        @click="mostrarModalConfiguracoesFinanceirosReceber()"
        v-if="(!processando)">
        <i class="fa fa-cog"></i> Contas a receber
      </button>

      <button 
        class="w3-button w3-theme margin-top10"
        @click="mostrarModalConfiguracoesDRE()"
        v-if="temResultado">
        <i class="fa fa-cog"></i> DRE
      </button>

      <button 
        class="w3-button w3-theme margin-top10"
        @click="mostrarModalConfiguracoesContasPagar()"
        v-if="temResultado">
        <i class="fa fa-cog"></i> Contas a pagar
      </button>

      <button 
        class="w3-button w3-green margin-top10"
        @click="gerarPlanilha()"
        v-if="temResultado">
        <i class="fa fa-file-excel"></i> Planilha
      </button>

      <button 
        class="w3-button w3-indigo margin-top10"
        v-if="temResultado"
        @click="atualizarListaConfiguracoesADMWeb(true, 'CON')">
        <i class="fas fa-file-upload"></i> Configurações salvas
      </button>

      <button 
        class="w3-button w3-indigo margin-top10"
        @click="atualizarListaConfiguracoesADMWeb(true, 'AFE')">
        <i class="fas fa-file-upload"></i> Processamentos salvos
      </button>

      <button 
        class="w3-button w3-blue margin-top10"
        v-if="temResultado"
        @click="mostrarModalSalvarComo('CON')">
        <i class="fas fa-cloud-download-alt"></i> Salvar configurações
      </button>

      <button 
        class="w3-button w3-blue margin-top10"
        v-if="temResultado"
        @click="mostrarModalSalvarComo('AFE')">
        <i class="fas fa-cloud-download-alt"></i> Salvar dados processamento
      </button>
      
    </div>

    <div class="w3-row w3-container">
      <div class="w3-col l12">
        <label>Período:</label>
        <strong>{{configuracoes.periodo.periodo_selecionado}}</strong>
      </div>
    </div>

    <div class="w3-row w3-container w3-margin-bottom">
      <label>Empresas:</label>
      <strong v-if="nenhumaEmpresaSelecionada()" v-cloak>Nenhuma empresa selecionada</strong>
      <strong v-if="todasEmpresasSelecionadas()" v-cloak>Todas as empresas</strong>
      
      <ul class="lista-leitura-simples" v-if="(!todasEmpresasSelecionadas())" v-cloak>
        <li
          :key="getKeyListaEmpresas(empresa.empresa_id)"
          v-show="empresa.selecionada"
          v-for="empresa in configuracoes.empresas"
        >
          <strong>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</strong>
        </li>
      </ul>
    </div>

    <div class="w3-row w3-container">
      <div class="w3-col l12 w3-margin-bottom" v-if="processando" style="padding: 0 20%">
        <div class="w3-panel w3-theme">
          <p><i class="fa fa-sync-alt w3-spin"></i> O processamento pode demorar de 30 minutos a 1 hora</p>
        </div>
      </div>
    </div>

    <div
      class="w3-row w3-container"
      style="margin-bottom: 5px"
      v-if="(!temResultado) && (!processando)"
      v-cloak
    >
      <div class="w3-col l3 s12">
        <button class="w3-button w3-theme w3-block" @click="buscarDadosAfericaoLucro()">
          <i class="fa fa-play-circle"></i> Processar
        </button>
      </div>
    </div>

    <!-- BALANÇO FINANCEIRO -->

    <div class="w3-container" v-if="mostrar_informacoes && temResultado">
      <h4>BALANÇO FINANCEIRO</h4>
    </div>

    <div class="w3-container w3-margin-bottom w3-hide-small" v-if="mostrar_informacoes && temResultado && colunas.length > 14">
      <input type="checkbox" class="w3-check" v-model="mostrar_coluna_fixa" id="opcao-mostrar-coluna-fixa" @change="mudarColunaFixa()">
      <label for="opcao-mostrar-coluna-fixa">Fixar primeira coluna</label>
    </div>

    <div
      class="w3-row w3-container"
      v-if="temResultado && getLinhasRenderizadas[linhas.length -1].indice"
    >
      <div id="grid" class="w3-col">
      
        <div class="table-container">
          <table  id='dados-tabela' class="tabela-resultado" style="border-collapse: collapse;">
            <tbody v-if="linhas && linhas[linhas.length -1].indice">
              <tr :key="'linha' + linha.indice" v-for="linha in getLinhasRenderizadas" :class="buscarClasseLinha(linha.tipo)">
                <td
                  v-if="!mostrar_coluna_fixa"
                  :class="buscarClasseCelulaColunaFixa(linha.tipo, linha.natureza, linha.coluna_fixa.tipo_coluna, linha.coluna_fixa.variacao_zebra)">
                  {{linha.coluna_fixa.texto}}<span v-if="mostrar_planilha">
                  <i class="fas fa-chart-bar w3-btn" v-if="linha.tipo != 'DAT'" @click="criarGrafico(linha.indice, 0, false, linha.coluna_fixa.texto)"></i></span>
                  
                </td>
                <!-- td para mostrar coluna fixa-->
                
                <td
                  v-if="mostrar_coluna_fixa"
                  style="position:absolute; width: 22vw; top:auto; border-top-width: 1px;  overflow: hidden; z-index: 2;"
                  :class="buscarClasseCelulaColunaFixa(linha.tipo, linha.natureza, linha.coluna_fixa.tipo_coluna, linha.coluna_fixa.variacao_zebra)">
                  {{linha.coluna_fixa.texto}}
                  
                </td>
                
                <!-- td para ocupar espaço de coluna fixa para mostrar todos os dados important-->
                <td
                  v-if="mostrar_coluna_fixa"
                  style="width: 22vw; top:auto; border-top-width: 1px;  overflow: hidden; position: relative;"
                  :class="buscarClasseCelulaColunaFixa(linha.tipo, linha.natureza, linha.coluna_fixa.tipo_coluna, linha.coluna_fixa.variacao_zebra)">
                  {{linha.coluna_fixa.texto}}
                  
                </td>

                <td 
                  :key="'celula-' + celula.indice" 
                  v-for="celula in linha.celulas" 
                  v-if="celula != linha.celulas[1] && celula != linha.celulas[2]"
                  :colspan="celula.colspan"
                  width="100"
                  :class="buscarClasseCelula(linha.tipo, linha.natureza, celula.tipo_coluna, celula.variacao_zebra)">
                  {{celula.texto}}
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--grafico dos dados da tela-->
    <div class="w3-modal" style="display: block" v-if="mostrar_grafico">
      <div class="w3-modal-content w3-animate-zoom" >
      <span @click="mostrar_grafico = false, mais_posicao = 0" class="w3-button w3-display-topright w3-text-theme w3-large ">&times;</span>
      <h5 class="titulo w3-text-theme">Aferição de lucro</h5>
        <button class="w3-btn w3-blue" @click="criarGrafico(indice_atual, 4, true, titulo_grafico)"><i class="fas fa-chevron-left"></i></button>
        <button class="w3-btn  w3-blue" @click="criarGrafico(indice_atual, 4, false, titulo_grafico)"><i class="fas fa-chevron-right"></i></button>
        <VueApexCharts 
          style="margin-top:40px;"
          type=bar height="350" 
          :options="chartOptions"
          :series="series">
        </VueApexCharts>
      </div>
    </div>

    <!-- FIM -- BALANÇO FINANCEIRO -->

    <!-- MODAL DE CONFIGURAÇÕES INICIAIS -->
    <div id="modalConfiguracoesIniciais" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho"><i class="fa fa-cog"></i> Configurações Iniciais</h4>
          <span @click="cancelarConfiguracoesIniciais()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-row w3-container">
          <h5 class="texto-vermelho">Período</h5>
        </div>

        <div class="w3-row w3-container">
          <div class="w3-col m5 l3">
            <label>Mês inicial</label>

            <masked-input 
              v-model="configuracoes.periodo.data_inicial" 
              mask="11/1111"
              class="w3-border w3-input"
              @change="(false)"
              placeholder="Data inicial"/>

          </div>

          <div class="w3-col m5 l3">
            <label class="w3-hide-small">&nbsp;</label>
            <label>Mês final</label>

            <masked-input 
              v-model="configuracoes.periodo.data_final" 
              mask="11/1111"
              class="w3-border w3-input"
              @change="(false)"
              placeholder="Data final"/>
          
          </div>
        </div>

        <div class="w3-row w3-container w3-margin-top">
          <h5 class="texto-vermelho">Empresas</h5>
          <label class="link-vermelho" @click="selecionarTodasEmpresas()">(Selecionar todas)</label>
        </div>        

        <div class="w3-container w3-margin-top">
          <div>
            <div
              :key="getKeyListaEmpresaModal2Config(empresa.empresa_id)"
              v-for="empresa in configuracoes.empresas"
              v-cloak
            >
              <div class="w3-col l12 borda-pontilhada-base">
                <div class="checkbox-group">
                  <input
                    type="checkbox"
                    :id="buscarElementoEmpresa(empresa.empresa_id)"
                    class="switch-input"
                    v-model="empresa.selecionada"
                  >
                  <label class="switch-label" :for="buscarElementoEmpresa(empresa.empresa_id)">
                    <strong>{{empresa.empresa_id}} - {{empresa.nome_resumido}}</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="gravarConfiguracoesIniciais()">
            <i class="fa fa-check"></i> Gravar configurações
          </button>
        </div>
      </div>
    </div>


    <!-- MODAL DE CONFIGURAÇÕES SALVAS -->
    <div id="modalConfiguracoesSalvas" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i>
            <span>Configurações Salvas</span>
            <span v-if="processando_modal_dados_salvos"><i class="fa fa-sync-alt w3-spin"></i></span>
          </h4>
          
          <span @click="fecharModalConfiguracoesSalvas()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-row w3-container w3-margin-top">
          <label class="link-vermelho w3-right" @click="excluirTodasConfiguracoes()">Excluir todas</label>
          <label class="w3-right">&nbsp;|&nbsp;</label>
          <label class="link-vermelho w3-right" @click="excluirConfiguracoesAutomaticas()">Excluir automáticas</label>
        </div>

        <div class="w3-row w3-container" >
          <div class="w3-col l12 w3-margin-bottom" style="padding: 0 20%">
            <div class="w3-panel w3-theme">
              
            </div>
          </div>
        </div>

        <div class="w3-container w3-margin-top" v-if="!processando_modal_dados_salvos">
          <div class="w3-col l12 w3-margin-bottom">
            <table class="w3-table-all">
              <tbody>
                <tr
                  :key="configuracao.configuracao_usuario_id"
                  v-for="configuracao in configuracoes_salvas"
                  v-cloak
                >
                  <td>
                    <button 
                      class="w3-btn w3-theme w3-center"
                      @click="carregarConfiguracaoSalva(configuracao.configuracao_usuario_id)">
                      <span><i class="fas fa-file-import"></i></span>
                    </button>
                  </td>
                  <td>
                    <i v-if="configuracao.salvo_automaticamente == 'N'" class="fas fa-circle" style="color: blue"></i>
                    <i v-if="configuracao.salvo_automaticamente == 'S'" class="fas fa-bolt" style="color: green"></i>
                  </td>
                  <td>{{configuracao.data_hora_configuracao}}</td>
                  <td>{{configuracao.descricao}}</td>
                  <td>
                    <button 
                      class="w3-btn w3-theme w3-center"
                      @click="excluirConfiguracaoSalva(configuracao.configuracao_usuario_id)">
                      <span>&times;</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


    <!-- MODAL DE PROCESSAMENTOS SALVOS -->
    <div id="modalProcessamentosSalvos" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i>
            <span>Processamentos Salvos</span>
            <span v-if="processando_modal_dados_salvos"><i class="fa fa-sync-alt w3-spin"></i></span>
          </h4>
          <span @click="fecharModalProcessamentosSalvos()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-row w3-container w3-margin-top">
          <label class="link-vermelho w3-right" @click="excluirTodasConfiguracoes()">Excluir todas</label>
          <label class="w3-right">&nbsp;|&nbsp;</label>
          <label class="link-vermelho w3-right" @click="excluirConfiguracoesAutomaticas()">Excluir automáticas</label>
        </div>

        <div class="w3-container w3-margin-top">
          <div class="w3-col l12 w3-margin-bottom">
            <table class="w3-table-all">
              <tbody>
                <tr
                  :key="processamento.configuracao_usuario_id"
                  v-for="processamento in processamentos_salvos"
                  v-cloak
                >
                  <td>
                    <button 
                      class="w3-btn w3-theme w3-center"
                      @click="carregarConfiguracaoSalva(processamento.configuracao_usuario_id)">
                      <span><i class="fas fa-file-import"></i></span>
                    </button>
                  </td>
                  <td>
                    <i v-if="processamento.salvo_automaticamente == 'N'" class="fas fa-circle" style="color: blue"></i>
                    <i v-if="processamento.salvo_automaticamente == 'S'" class="fas fa-bolt" style="color: green"></i>
                  </td>
                  <td>{{processamento.data_hora_configuracao}}</td>
                  <td>{{processamento.descricao}}</td>
                  <td>
                    <button 
                      class="w3-btn w3-theme w3-center"
                      @click="excluirConfiguracaoSalva(processamento.configuracao_usuario_id)">
                      <span>&times;</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>


    <div id="modalSalvarComo" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho"><i class="fa fa-cog"></i> Salvar Como</h4>
          <span @click="fecharModalSalvarComo()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-container w3-margin-top">
          <label>Nome</label>
          <input class="w3-input w3-border" ref="campo_nome_salvar" v-model="nome_salvar" maxlength="100"/>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="salvarConfiguracoes()">
            <i class="fa fa-check"></i> Salvar
          </button>
        </div>
      </div>
    </div>


    <!-- MODAL DE CONFIGURAÇÕES CONTAS -->
    <div id="modalConfiguracoesContas" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Contas
          </h4>
          <span @click="cancelarConfiguracoesContas()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-container" v-if="afericao_lucro">
          <label class="link-vermelho" style="cursor: pointer" @click="selecionarTodasContas()">(Selecionar todas)</label>

          <div class="w3-col l12 w3-margin-bottom w3-margin-top">
            <table class="w3-table-all">
              <thead>
                <tr>
                  <th>Conta</th>
                  <th>Nome do portador</th>
                  <th>Empresa</th>
                  <th>Tipo analítico</th>
                  <th>Tipo conta</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  :key="getKeyListaContaModal3Config(conta.conta_id)"
                  v-for="conta in configuracoes.contas"
                  style="cursor: pointer"
                  v-cloak
                >
                  <td>
                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        :id="buscarElementoContaLarge(conta.conta_id)"
                        class="switch-input"
                        v-model="conta.selecionada"
                        :checked="conta.selecionada"
                      >
                      <label class="switch-label" :for="buscarElementoContaLarge(conta.conta_id)">
                        <strong>{{conta.conta_id}}</strong>
                      </label>
                    </div>
                  </td>
                  <td>{{conta.nome_portador}}</td>
                  <td>{{conta.empresa_id}} - {{conta.nome_empresa}}</td>
                  <td>{{conta.tipo_analitico}}</td>
                  <td>
                    <select class="w3-input" v-model="conta.tipo_conta">
                      <option value="CAI">Caixa/Bancária</option>
                      <option value="APL">Aplicação</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="w3-container w3-center w3-margin-top">
          <button class="w3-button w3-theme" @click="gravarConfiguracoesContas()">
            <i class="fa fa-check"></i> Gravar configurações
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÕES DE PLANO FINANCEIRO -->
    <div id="modalConfiguracoesPlanos" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações da DRE
          </h4>
          <span @click="cancelarConfiguracoesDRE()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-container w3-margin-bottom">
          <div class="w3-col m4 s12">
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="checkMostrarTitulosDefinidosPrejuizo"
                class="switch-input"
                v-model="configuracoes.mostrar_titulos_definidos_prejuizo"
              >
              <label class="switch-label" for="checkMostrarTitulosDefinidosPrejuizo"><strong>Mostrar títulos def. prejuízo</strong></label>
            </div>
          </div>

          <div class="w3-col m4 s12">
            <div class="checkbox-group">
              <input
                type="checkbox"
                id="checkMostrarPercasEstoque"
                class="switch-input"
                v-model="configuracoes.mostrar_perca_estoque"
              >
              <label class="switch-label" for="checkMostrarPercasEstoque"><strong>Mostrar perca de estoque</strong></label>
            </div>
          </div>
        </div>

        <div>
          <div class="w3-col m3 s12 w3-padding">
            <label class="w3-block">Cód. plano começam com:</label>
            <input type="text" class="w3-input w3-border" v-model="filtro_mascara_dre"/>
          </div>

          <div class="w3-col m3 s12 w3-padding">
            <label class="w3-block">Nome que contém:</label>
            <input type="text" class="w3-input w3-border" v-model="filtro_nome_dre"/>
          </div>

          <div class="w3-col m6 s12 w3-padding">
            <label class="w3-block">Marcar visíveis como:</label>
            
            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme" @click="marcarVisiveisTipoPlanoDRE('NEN')">Não mostrar</button>
            </div>

            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme" @click="marcarVisiveisTipoPlanoDRE('ATI')">Investimento</button>
            </div>

            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme w3-block" @click="marcarVisiveisTipoPlanoDRE('DLU')">Sócios</button>
            </div>
          </div>
        </div>


        <div class="w3-container w3-col s12" v-show="mostrarControlePaginasDRE()">
          <b class="w3-right">Página {{pagina_atual_dre}} / {{quantidade_paginas_dre}}</b>
        </div>

        <div class="w3-container w3-margin-bottom" v-show="mostrarControlePaginasDRE()">
          <button class="w3-btn w3-theme" id="btPrimeira" @click="primeiraPaginaPlano">
            <i class="fa fa-angle-double-left"></i>
          </button>

          <button class="w3-btn w3-theme" id="btAnterior" @click="paginaAnteriorPlano">
            <i class="fa fa-angle-left"></i>
          </button>

          <button class="w3-btn w3-theme" id="btProxima" @click="proximaPaginaPlano">
            <i class="fa fa-angle-right"></i>
          </button>

          <button class="w3-btn w3-theme" id="btUltima" @click="ultimaPaginaPlano">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>

        <div v-if="configuracoes && configuracoes.demonstrativo_fluxo_caixa">
          <div
            class="w3-container borda-pontilhada-topo"
            :key="getKeyListaPlanFinConfigDRE(plano_financeiro.plano_financeiro_id)"
            v-show="podeMostrarItemDRE(plano_financeiro.indice, plano_financeiro.plano_financeiro_id, plano_financeiro.nome_plano_financeiro)"
            v-for="plano_financeiro in configuracoes.demonstrativo_fluxo_caixa"
            v-cloak
          >
            <div class="w3-col l12 m12">
              <strong :class="buscarClasseCorPlanoFinanceiro(plano_financeiro.tipo)">
                {{plano_financeiro.plano_financeiro_id}} - {{plano_financeiro.nome_plano_financeiro}}
              </strong>

              <label>
                &nbsp;&nbsp;/&nbsp;&nbsp;
                {{plano_financeiro.saldos[0].mes_ano}}:
                &nbsp;
              </label>

              <strong>
                {{nPadrao(plano_financeiro.saldos[0].saldo, 2)}}
              </strong>

              <label>
                &nbsp;&nbsp;/&nbsp;&nbsp;
                {{plano_financeiro.saldos[plano_financeiro.saldos.length -1].mes_ano}}:
                &nbsp;
              </label>

              <strong>
                {{nPadrao(plano_financeiro.saldos[plano_financeiro.saldos.length -1].saldo, 2)}}
              </strong>
            </div>

            <div class="w3-col l3 m6 w3-margin-bottom">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'NEN')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="NEN"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'NEN')"
              >Não mostrar</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'ATI')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="ATI"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'ATI')"
              >Ativo - investimento</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'DLU')"
                :name="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="DLU"
              >
              <label
                :for="buscarElementoPlanoFinanceiro(plano_financeiro.plano_financeiro_id, 'DLU')"
              >Sócios</label>
            </div>
          </div>

          <div class="w3-container w3-margin-top" v-show="mostrarControlePaginasDRE()">
            <button class="w3-button w3-btn w3-theme" id="btPrimeira" @click="primeiraPaginaPlano">
              <i class="fa fa-angle-double-left"></i>
            </button>

            <button class="w3-button w3-btn w3-theme" id="btAnterior" @click="paginaAnteriorPlano">
              <i class="fa fa-angle-left"></i>
            </button>

            <button class="w3-button w3-btn w3-theme" id="btProxima" @click="proximaPaginaPlano">
              <i class="fa fa-angle-right"></i>
            </button>

            <button class="w3-button w3-btn w3-theme" id="btUltima" @click="ultimaPaginaPlano">
              <i class="fa fa-angle-double-right"></i>
            </button>
          </div>

          <div class="w3-container w3-col s12" v-show="mostrarControlePaginasDRE()">
            <b class="w3-right">Página {{pagina_atual_dre}} / {{quantidade_paginas_dre}}</b>
          </div>

          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesDRE()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE CONFIGURAÇÕES DE FINANCEIROS A PAGAR -->
    <div id="modalConfiguracoesContasPagar" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Financeiros a Pagar
          </h4>

          <span @click="cancelarConfiguracoesContasPagar()" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div>
          <div class="w3-col m3 s12 w3-padding">
            <label class="w3-block">Cód. plano começam com:</label>
            <input type="text" class="w3-input w3-border" v-model="filtro_mascara_contas_pagar"/>
          </div>

          <div class="w3-col m3 s12 w3-padding">
            <label class="w3-block">Nome que contém:</label>
            <input type="text" class="w3-input w3-border" v-model="filtro_nome_contas_pagar"/>
          </div>

          <div class="w3-col m6 s12 w3-padding">
            <label class="w3-block">Marcar visíveis como:</label>
            
            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme" @click="marcarVisiveisTipoPlanoContasPagar('NEN')">Não mostrar</button>
            </div>

            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme" @click="marcarVisiveisTipoPlanoContasPagar('PAO')">Operacional</button>
            </div>

            <div class="w3-col m4 s12">
              <button class="w3-button w3-theme w3-block" @click="marcarVisiveisTipoPlanoContasPagar('PAI')">Investimento</button>
            </div>            
          </div>
        </div>

        <div class="w3-container w3-col s12" v-show="mostrarControlePaginasContasPagar()">
          <b class="w3-right">Página {{pagina_atual_financeiros_pag}} / {{quantidade_paginas_financeiros_pag}}</b>
        </div>

        <div class="w3-container w3-margin-bottom" v-show="mostrarControlePaginasContasPagar()">
          <button class="w3-btn w3-theme" id="btPrimeira" @click="primeiraPaginaFinanceirosPag">
            <i class="fa fa-angle-double-left"></i>
          </button>

          <button class="w3-btn w3-theme" id="btAnterior" @click="paginaAnteriorFinanceirosPag">
            <i class="fa fa-angle-left"></i>
          </button>

          <button class="w3-btn w3-theme" id="btProxima" @click="proximaPaginaFinanceirosPag">
            <i class="fa fa-angle-right"></i>
          </button>

          <button class="w3-btn w3-theme" id="btUltima" @click="ultimaPaginaFinanceirosPag">
            <i class="fa fa-angle-double-right"></i>
          </button>
        </div>


        <div v-if="configuracoes && configuracoes.financeiros_pagar">
          <div
            class="w3-container borda-pontilhada-topo"
            :key="getKeyListaConfigContasPagar(plano_financeiro.plano_financeiro_id)"
            v-show="podeMostrarItemContasPagar(plano_financeiro.indice, plano_financeiro.plano_financeiro_id, plano_financeiro.nome_plano_financeiro)"
            v-for="plano_financeiro in configuracoes.financeiros_pagar"
            v-cloak
          >

            <div class="w3-col l12 m12">
              <strong>{{descricaoPlanoFinanceiro(plano_financeiro)}}</strong>

              <label>
                &nbsp;&nbsp;/&nbsp;&nbsp;
                {{plano_financeiro.saldos[0].mes_ano}}:
                &nbsp;
              </label>

              <strong>
                {{nPadrao(plano_financeiro.saldos[0].saldo, 2)}}
              </strong>

              <label>
                &nbsp;&nbsp;/&nbsp;&nbsp;
                {{plano_financeiro.saldos[plano_financeiro.saldos.length -1].mes_ano}}:
                &nbsp;
              </label>

              <strong>
                {{nPadrao(plano_financeiro.saldos[plano_financeiro.saldos.length -1].saldo, 2)}}
              </strong>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'NEN')"
                :name="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="NEN"
              >
              <label :for="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'NEN')">Não mostrar</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'PAO')"
                :name="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="PAO"
              >
              <label :for="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'PAO')">Passivo operacional</label>
            </div>

            <div class="w3-col l3 m6">
              <input
                type="radio"
                class="w3-radio"
                :id="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'PAI')"
                :name="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, '')"
                v-model="plano_financeiro.tipo_plano"
                value="PAI"
              >
              <label :for="buscarElementoContaPagar(plano_financeiro.plano_financeiro_id, 'PAI')">Passivo investimento</label>
            </div>
          </div>

          <div class="w3-container w3-margin-top" v-show="mostrarControlePaginasContasPagar()">
            <button class="w3-btn w3-theme" id="btPrimeira" @click="primeiraPaginaFinanceirosPag">
              <i class="fa fa-angle-double-left"></i>
            </button>

            <button class="w3-btn w3-theme" id="btAnterior" @click="paginaAnteriorFinanceirosPag">
              <i class="fa fa-angle-left"></i>
            </button>

            <button class="w3-btn w3-theme" id="btProxima" @click="proximaPaginaFinanceirosPag">
              <i class="fa fa-angle-right"></i>
            </button>

            <button class="w3-btn w3-theme" id="btUltima" @click="ultimaPaginaFinanceirosPag">
              <i class="fa fa-angle-double-right"></i>
            </button>
          </div>

          <div class="w3-container w3-col s12" v-show="mostrarControlePaginasContasPagar()">
            <b class="w3-right">Página {{pagina_atual_financeiros_pag}} / {{quantidade_paginas_financeiros_pag}}</b>
          </div>

          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesContasPagar()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>

        </div>
      </div>
    </div>


    <!-- MODAL DE CONFIGURAÇÕES DE FINANCEIROS A RECEBER -->
    <div id="modalConfiguracoesFinanceirosReceber" class="w3-modal">
      <div class="w3-modal-content w3-animate-zoom">
        <header class="w3-container">
          <h4 class="texto-vermelho">
            <i class="fa fa-cog"></i> Configurações de Financeiros a Receber
          </h4>

          <button class="w3-button w3-theme w3-block" @click="mostrar_pesquisa_cadastros = true">
            <i class="fa fa-cog"></i> Omitir cadastro
          </button>

          <span
            @click="cancelarConfiguracoesFinanceirosReceber()"
            class="w3-button w3-display-topright"
          >&times;</span>
        </header>
        
        <div class="w3-container" v-if="configuracoes && configuracoes.usuarios_omitir_contas_receber">
          <strong class="w3-block">Cadastros omitidos na consulta de contas a receber</strong>
          
          <label v-if="configuracoes.usuarios_omitir_contas_receber.length == 0" class="w3-block">
            Nenhum
          </label>
          
          <table class="w3-table-all" v-if="configuracoes.usuarios_omitir_contas_receber.length != 0">
            <thead>
              <tr>
                <th>Cadastro</th>
                <th class="sem-quebra">CPF/CNPJ</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                class="label-clicavel" 
                :key="cadastro.cadastro_id" 
                v-for="cadastro in configuracoes.usuarios_omitir_contas_receber">

                <td>{{cadastro.cadastro_id}} - {{cadastro.nome_razao_social}}</td>
                <td class="sem-quebra">{{cadastro.cpf_cnpj}}</td>
                <th>
                  <button 
                    class="w3-button w3-theme w3-center" 
                    @click="retirarCadastroListaOmissaoContasReceber(cadastro.cadastro_id)">X
                  </button>
                </th>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="w3-container" v-if="afericao_lucro && alterou_cadastros_contas_receber">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="reprocessarFinanceirosReceber()">
              <i class="fas fa-sync-alt"></i> Reprocessar financeiros a receber
            </button>
          </div>
        </div>

        <div class="w3-container" v-if="!afericao_lucro || !alterou_cadastros_contas_receber">
          <div class="w3-container w3-center w3-margin-top">
            <button class="w3-button w3-theme" @click="gravarConfiguracoesFinanceirosReceber()">
              <i class="fa fa-check"></i> Gravar configurações
            </button>
          </div>
        </div>

      </div>
    </div>

    <pesquisa-cadastros 
      v-if="mostrar_pesquisa_cadastros" 
      @selecionar="selecionarCadastroOmitirContasReceber" 
      @fechar="mostrar_pesquisa_cadastros = false">
    </pesquisa-cadastros>
    <iframe id="txtArea1" style="display:none"></iframe>
  </div>
  
</template>

<script>
import moment from 'moment'
import NavMenu from '@/components/Menu'
import toastr from 'toastr'
import { exists } from "fs"
import MaskedInput from 'vue-masked-input'
import PesquisaCadastros from '@/components/Pesquisas/PesquisaCadastros'
import RAfericaoLucro from '@/components/Rest/RAfericaoLucro.js'
import RConfiguracaoUsuarioADMWeb from '@/components/Rest/RConfiguracaoUsuarioADMWeb'
import REmpresa from '@/components/Rest/REmpresa'
import Biblioteca from '@/components/Repositorio/Biblioteca.js'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "AfericaoLucro2",
  components: {
    NavMenu,
    MaskedInput,
    PesquisaCadastros,
    VueApexCharts
  },
  data() {
    return {
      api: process.env.API,
      processando: false,
      processando_modal_dados_salvos: false,
      width: undefined,
      mostrar_planilha: true,
      mostrar_grafico: false,
      chartOptions: {}, 
      series: [], 
      indice_atual: 0,
      mais_posicao: 0,
      titulo_grafico: "",

      /* ****************** Objetos e vetores independentes ****************** */
      afericao_lucro: undefined,
      ver_planilha: [],

      configuracoes: {
        periodo: {
          periodo_selecionado: '',
          data_inicial: '',
          data_final: ''
        },
        empresas: []
      },

      configuracoes_salvas: [],
      processamentos_salvos: [],

      /* ****************** Alimentado na inicialização ****************** */
      todas_empresas: [],

      /* ****************** Gerenciamento de modais e visual ****************** */
      mostrar_coluna_fixa: false,
      mostrar_informacoes: true,
      mostrar_pesquisa_cadastros: false,

      pagina_atual_dre: 0,
      quantidade_paginas_dre: 0,

      pagina_atual_financeiros_pag: 0,
      quantidade_paginas_financeiros_pag: 0,


      filtro_mascara_dre: '',
      filtro_nome_dre: '',
      filtro_nome_contas_pagar: '',
      filtro_mascara_contas_pagar: '',

      tipo_configuracao: '',
      nome_salvar: '',

      linhas: [],

      /* TODO: ****************** ? ****************** */
      colunas: [],
      alterou_cadastros_contas_receber: false,

      /* ****************** Constantes ****************** */
      c_quantidade_por_pagina: 20,
      c_afericao_lucro_configuracoes: 'afericao-lucro-configuracoes',
      c_afericao_lucro_ultimos_dados: 'afericao-lucro-ultimos-dados'
    }
  },
  methods: {
    abrirModalPesquisaCadastros() {
      this.$refs.pesquisaCadastros.abrir();      
    },

    ajustarPaginacoes: function() {
      /* Ajustando paginação da tela de contas a pagar */
      this.pagina_atual_financeiros_pag = 1
      if (this.afericao_lucro.financeiros_pagar) {
        for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
          this.afericao_lucro.financeiros_pagar[i].indice = i + 1
        }
      }

      if (this.afericao_lucro.financeiros_pagar) {
        if (this.afericao_lucro.financeiros_pagar.length < this.c_quantidade_por_pagina) {
          this.quantidade_paginas_financeiros_pag = 1
        } else {
          this.quantidade_paginas_financeiros_pag = Math.trunc(
            this.afericao_lucro.financeiros_pagar.length / this.c_quantidade_por_pagina
          )

          if (this.afericao_lucro.financeiros_pagar.length % this.c_quantidade_por_pagina > 0) {
            this.quantidade_paginas_financeiros_pag += 1
          }
        }
      }

      /* Ajustando paginação da tela DRE */
      this.pagina_atual_dre = 1

      if (this.afericao_lucro.demonstrativo_fluxo_caixa) {
        for (let i = 0; i < this.afericao_lucro.demonstrativo_fluxo_caixa.length; i++) {
          this.afericao_lucro.demonstrativo_fluxo_caixa[i].indice = i + 1
        }
      }

      if (this.afericao_lucro.demonstrativo_fluxo_caixa) {
        if (this.afericao_lucro.demonstrativo_fluxo_caixa.length < this.c_quantidade_por_pagina) {
          this.quantidade_paginas_dre = 1
        } else {
          this.quantidade_paginas_dre = Math.trunc(
            this.afericao_lucro.demonstrativo_fluxo_caixa.length / this.c_quantidade_por_pagina
          )

          if (this.afericao_lucro.demonstrativo_fluxo_caixa.length % this.c_quantidade_por_pagina > 0) {
            this.quantidade_paginas_dre += 1
          }
        }
      }
    },

    buscarClasseCorPlanoFinanceiro(tipo) {
      if (tipo == 'R') {
        return 'cor-verde ';
      }
      else if (tipo == 'D') {
        return 'cor-vermelha ';
      }
    },

    aplicarConfiguracoesPadrao() {
      this.atualizarPeriodoSelecionado(false);
      this.verificarDadosConfiguracoes(false);
    },

    fecharModalConfiguracoesIniciais() {
      this.mostrar_informacoes = true;
      $('#modalConfiguracoesIniciais').removeAttr('style').hide();
    },

    mostrarModalConfiguracoesIniciais(tipo) {
      this.mostrar_informacoes = false;
      $('#modalConfiguracoesIniciais').toggle(100);
    },

    fecharModalConfiguracoesSalvas() {
      this.mostrar_informacoes = true;
      $('#modalConfiguracoesSalvas').removeAttr('style').hide();
    },

    fecharModalProcessamentosSalvos() {
      this.mostrar_informacoes = true;
      $('#modalProcessamentosSalvos').removeAttr('style').hide();
    },

    fecharModalSalvarComo() {
      this.mostrar_informacoes = true;
      $('#modalSalvarComo').removeAttr('style').hide();
    },

    salvarConfiguracoes() {
      this.gravarConfiguracoesUsuario(this.nome_salvar, this.tipo_configuracao, 'N');
      this.fecharModalSalvarComo();
    },

    async carregarConfiguracaoSalva(configuracao_usuario_id) {
      try {
        let chave = this.c_afericao_lucro_ultimos_dados;

        if (this.tipo_configuracao == 'CON') {
          chave = this.c_afericao_lucro_configuracoes;
        }

        let parametros = {
          configuracao_usuario_id: configuracao_usuario_id
        }

        this.processando_modal_dados_salvos = true;

        let retorno = await RConfiguracaoUsuarioADMWeb.buscarConfiguracoesPorId(
          this.axios,
          parametros
        );
        
        if (this.tipo_configuracao == 'CON') {
          this.configuracoes = JSON.parse(JSON.stringify(retorno.dados.configuracao));

          this.ajustarProcessamentoAfericaoLucro();
          if (this.tipo_configuracao == 'CON') {
            this.fecharModalConfiguracoesSalvas();
          }
          else {
            this.fecharModalProcessamentosSalvos();
          }

          toastr.info('Configurações carregadas com sucesso.');
        }
        else {
          this.afericao_lucro = JSON.parse(JSON.stringify(retorno.dados.configuracao));

          this.ajustarProcessamentoAfericaoLucro();
          if (this.tipo_configuracao == 'CON') {
            this.fecharModalConfiguracoesSalvas();
          }
          else {
            this.fecharModalProcessamentosSalvos();
          }

          toastr.info('Dados de processamento carregados com sucesso.');
        }

        this.processando_modal_dados_salvos = false;
      }
      catch(e) {
        this.processando_modal_dados_salvos = false;
        toastr.error(e.message);
      }
    },

    verificarErro(erro){
      this.finalizarProcessando()
      let mensagem = Biblioteca.tratamentoMensagem(erro);
      Biblioteca.exclamar(mensagem);
    },

    async atualizarListaConfiguracoesADMWeb(mostrar_modal, tipo_configuracao) {
      try {
        this.tipo_configuracao = tipo_configuracao;
        let chave = this.c_afericao_lucro_ultimos_dados;
        let modal = '#modalProcessamentosSalvos';
        let mensagem_nao_salvo = 'Nâo há processamentos salvos.';
        
        if (tipo_configuracao == 'CON') {
          chave = this.c_afericao_lucro_configuracoes;
          modal = '#modalConfiguracoesSalvas';
          mensagem_nao_salvo = 'Nâo há configurações salvas.';
          this.configuracoes_salvas = [];
        }
        else {
          this.processamentos_salvos = []
        }

        this.processando_modal_dados_salvos = true;

        let parametros = {
          chave: chave
        }
        
        let retorno = await RConfiguracaoUsuarioADMWeb.buscarConfiguracoesPorChave(
          this.axios,
          parametros
        );

        if (retorno.houve_erro != 'N') {
          this.fecharModalConfiguracoesSalvas();          
          throw new Error(retorno.mensagem);
        }

        if (tipo_configuracao == 'CON') {
          this.configuracoes_salvas = JSON.parse(
            JSON.stringify(retorno.dados)
          )
        }
        else {
          this.processamentos_salvos = JSON.parse(
            JSON.stringify(retorno.dados)
          )
        }

        this.processando_modal_dados_salvos = false;

        if (mostrar_modal) {
          $(modal).toggle(100);
        }
      }
      catch(e) {
        toastr.error(e.message);
        this.processando_modal_dados_salvos = false;
      }
    },

    gravarConfiguracoesIniciais() {
      if (this.verificarDadosConfiguracoes(true)) {
        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }

        this.fecharModalConfiguracoesIniciais()
      }
    },

    cancelarConfiguracoesIniciais() {
      this.verificarDadosConfiguracoes(false)
      this.fecharModalConfiguracoesIniciais()
    },

    mostrarModalConfiguracoesContas() {
      this.mostrar_informacoes = false
      $('#modalConfiguracoesContas').toggle(100)
    },

    mostrarModalSalvarComo(tipo_configuracao) {
      this.tipo_configuracao = tipo_configuracao
      this.mostrar_informacoes = false
      $('#modalSalvarComo').toggle(100)
      this.$nextTick(() =>this.$refs.campo_nome_salvar.focus())
    },

    cancelarConfiguracoesContas() {
      this.fecharModalConfiguracoesContas()
    },


    gravarConfiguracoesContas() {
      if (this.aplicarConfiguracoesContas()) {
        if (this.gravarConfiguracoesUsuario()) {
          this.fecharModalConfiguracoesContas()
        }
      }
    },

    fecharModalConfiguracoesContas() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesContas').removeAttr('style').hide()
    },

    mostrarModalConfiguracoesDRE() {
      if (!this.afericao_lucro.demonstrativo_fluxo_caixa) {
        toastr.error('A DRE não tem dados no período selecionado!')
        return
      }

      this.mostrar_informacoes = false;
      $('#modalConfiguracoesPlanos').toggle(100)
    },

    fecharModalConfiguracoesDRE() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesPlanos').removeAttr('style').hide()
    },

    mostrarModalConfiguracoesContasPagar() {
      if (!this.afericao_lucro.financeiros_pagar) {
        toastr.error('Nenhum financeiro a pagar foi encontrado no período selecionado!')
        return
      }

      this.mostrar_informacoes = false;
      $('#modalConfiguracoesContasPagar').toggle(100)
    },

    fecharModalConfiguracoesContasPagar() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesContasPagar').removeAttr('style').hide()
    },

    cancelarConfiguracoesContasPagar() {
      this.fecharModalConfiguracoesContasPagar()
    },

    mostrarModalConfiguracoesFinanceirosReceber() {
      this.mostrar_informacoes = false
      $('#modalConfiguracoesFinanceirosReceber').toggle(100)
    },

    fecharModalConfiguracoesFinanceirosReceber() {
      this.mostrar_informacoes = true
      $('#modalConfiguracoesFinanceirosReceber').removeAttr('style').hide()
    },

    cancelarConfiguracoesFinanceirosReceber() {
      this.fecharModalConfiguracoesFinanceirosReceber()
    },

    gravarConfiguracoesFinanceirosReceber() {
      if (this.verificarDadosConfiguracoes(true)) {

        if (this.afericao_lucro) {
          this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
        }
        
        this.fecharModalConfiguracoesFinanceirosReceber()
      }
    },

    descricaoPlanoFinanceiro(plano_financeiro) {
      if ((plano_financeiro.plano_financeiro_id == '0.000') || (plano_financeiro.plano_financeiro_id == '0.001')) {
        return plano_financeiro.nome_plano_financeiro
      }
      else {
        return plano_financeiro.plano_financeiro_id + ' - ' + plano_financeiro.nome_plano_financeiro
      }
    },

    primeiraPaginaPlano: function() {
      this.pagina_atual_dre = 1
    },

    paginaAnteriorPlano: function() {
      if (this.pagina_atual_dre > 1) {
        this.pagina_atual_dre -= 1
      }
    },

    proximaPaginaPlano: function() {
      if (this.pagina_atual_dre < this.quantidade_paginas_dre) {
        this.pagina_atual_dre += 1
      }
    },

    ultimaPaginaPlano: function() {
      this.pagina_atual_dre = this.quantidade_paginas_dre
    },

    primeiraPaginaFinanceirosPag: function() {
      this.pagina_atual_financeiros_pag = 1
    },

    paginaAnteriorFinanceirosPag: function() {
      if (this.pagina_atual_financeiros_pag > 1) {
        this.pagina_atual_financeiros_pag -= 1
      }
    },

    proximaPaginaFinanceirosPag: function() {
      if (this.pagina_atual_financeiros_pag < this.quantidade_paginas_financeiros_pag) {
        this.pagina_atual_financeiros_pag += 1
      }
    },

    ultimaPaginaFinanceirosPag: function() {
      this.pagina_atual_financeiros_pag = this.quantidade_paginas_financeiros_pag;
    },

    temFiltroMascaraDRE() {
      if ((this.filtro_mascara_dre) && (this.filtro_mascara_dre.length > 0)) {
        return true
      }

      return false
    },

    temFiltroNomeDRE() {
      if ((this.filtro_nome_dre) && (this.filtro_nome_dre.length > 0)) {
        return true
      }

      return false
    },

    temFiltroMascaraContasPagar() {
      if ((this.filtro_mascara_contas_pagar) && (this.filtro_mascara_contas_pagar.length > 0)) {
        return true
      }

      return false
    },

    temFiltroNomeContasPagar() {
      if ((this.filtro_nome_contas_pagar) && (this.filtro_nome_contas_pagar.length > 0)) {
        return true
      }

      return false
    },

    temFiltroDRE() {
      if (this.temFiltroMascaraDRE()) {
        return true
      }

      if (this.temFiltroNomeDRE()) {
        return true
      }

      return false
    },

    mostrarControlePaginasDRE() {
      if (this.quantidade_paginas_dre > 1) {
        return !this.temFiltroDRE()
      }
      else {
        return false
      }
    },

    mostrarControlePaginasContasPagar() {
      if (this.quantidade_paginas_financeiros_pag > 1) {
        return !this.temFiltroContasPagar()
      }
      else {
        return false
      }
    },

    temFiltroContasPagar() {
      if (this.temFiltroMascaraContasPagar()) {
        return true
      }

      if (this.temFiltroNomeContasPagar()) {
        return true
      }

      return false
    },

    marcarVisiveisTipoPlanoDRE(tipo_plano) {
      if ((!this.configuracoes) || ((!this.configuracoes.demonstrativo_fluxo_caixa))) {
        return
      }

      for (let i = 0; i < this.configuracoes.demonstrativo_fluxo_caixa.length; i++) {
        if (
          this.podeMostrarItemDRE(
            this.configuracoes.demonstrativo_fluxo_caixa[i].indice, 
            this.configuracoes.demonstrativo_fluxo_caixa[i].plano_financeiro_id, 
            this.configuracoes.demonstrativo_fluxo_caixa[i].nome_plano_financeiro
          )
        ) {
          this.configuracoes.demonstrativo_fluxo_caixa[i].tipo_plano = tipo_plano
        }
      }

      this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes))
    },

    marcarVisiveisTipoPlanoContasPagar(tipo_plano) {
      if ((!this.configuracoes) || ((!this.configuracoes.financeiros_pagar))) {
        return
      }

      for (let i = 0; i < this.configuracoes.financeiros_pagar.length; i++) {
        if (
          this.podeMostrarItemDRE(
            this.configuracoes.financeiros_pagar[i].indice, 
            this.configuracoes.financeiros_pagar[i].plano_financeiro_id, 
            this.configuracoes.financeiros_pagar[i].nome_plano_financeiro
          )
        ) {
          this.configuracoes.financeiros_pagar[i].tipo_plano = tipo_plano
        }
      }

      this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes))
    },

    podeMostrarItemDRE(indice, plano_financeiro_id, nome) {
      let retorno = false

      if (this.temFiltroMascaraDRE()) {
        retorno = plano_financeiro_id.startsWith(this.filtro_mascara_dre)
        if (retorno) {
          return retorno
        }
      }

      if (this.temFiltroNomeDRE()) {
        retorno = nome.toUpperCase().includes(this.filtro_nome_dre.toUpperCase())
        if (retorno) {
          return retorno
        }
      }

      if (!this.temFiltroDRE()) {
        let item_final = this.pagina_atual_dre * this.c_quantidade_por_pagina
        let item_inicial = item_final - this.c_quantidade_por_pagina + 1

        retorno = ((indice >= item_inicial) && (indice <= item_final))
      }

      return retorno
    },

    podeMostrarItemContasPagar(indice, plano_financeiro_id, nome) {
      let retorno = false

      if (this.temFiltroMascaraContasPagar()) {
        retorno = plano_financeiro_id.startsWith(this.filtro_mascara_contas_pagar)
        if (retorno) {
          return retorno
        }
      }

      if (this.temFiltroNomeContasPagar()) {
        retorno = nome.toUpperCase().includes(this.filtro_nome_contas_pagar.toUpperCase())
        if (retorno) {
          return retorno
        }
      }

      if (!this.temFiltroContasPagar()) {
        let item_final = this.pagina_atual_financeiros_pag * this.c_quantidade_por_pagina
        let item_inicial = item_final - this.c_quantidade_por_pagina + 1

        return ((indice >= item_inicial) && (indice <= item_final))
      }

      return retorno
    },

    cancelarConfiguracoesDRE() {
      this.fecharModalConfiguracoesDRE()
    },

    verificarDadosConfiguracoes(gravar_dispositivo) {
      let periodo = this.configuracoes.periodo

      if (!this.atualizarPeriodoSelecionado(gravar_dispositivo)) {
        return
      }

      /* Sempre por último */
      if (gravar_dispositivo) {
        if (this.afericao_lucro && this.afericao_lucro.planos_financeiros) {
          this.configuracoes.planos_financeiros = []

          for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
            this.configuracoes.planos_financeiros.push({
              plano_financeiro_id: this.afericao_lucro.planos_financeiros[i].plano_financeiro_id,
              tipo_plano: this.afericao_lucro.planos_financeiros[i].tipo_plano
            })
          }
        }

        if (this.afericao_lucro && this.afericao_lucro.financeiros_pagar) {
          this.configuracoes.financeiros_pagar = [];

          for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
            this.configuracoes.financeiros_pagar.push({
              plano_financeiro_id: this.afericao_lucro.financeiros_pagar[i].plano_financeiro_id,
              selecionado: this.afericao_lucro.financeiros_pagar[i].selecionado
            })
          }
        }

        localStorage.setItem(this.c_afericao_lucro_configuracoes, JSON.stringify(this.configuracoes))
      }

      return true;
    },

    mostrarPlanoContasPagar(plano_financeiro_id) {
      if (plano_financeiro_id == '0.000') {
        return ''
      }
      else {
        return plano_financeiro_id + ' - '
      }
    },

    getKeyContaPagar(planoFinanceiroId) {
      return 'planoPagar' + planoFinanceiroId
    },

    getKeyListaEmpresas(empresaId) {
      return 'listaEmpresa' + empresaId
    },

    getKeyListaContaId(contaId) {
      return 'listaConta' + contaId
    },

    getKeyListaTabelaContaId(contaId) {
      return 'listaTabelaConta' + contaId
    },

    getKeyTipoSintFinReceber(tipoSintetico) {
      return 'tipoSinteticoFinReceber' + tipoSintetico
    },

    getKeyListaTipoSintFinRecTab(tipoSintetico) {
      return 'listaTipoSintFinRecTab' + tipoSintetico
    },

    getKeyEmpresaInventario(empresaId) {
      return 'empresaInventario' + empresaId
    },

    getKeyInventarioTabEmpresa(empresaId) {
      return 'inventarioTabEmpresa' + empresaId
    },

    getKeyPlanoFinAtInvest(planoFinanceiroId) {
      return 'planoFinAtInvest' + planoFinanceiroId
    },

    getKeyPlanoFinTabAtInvest(planoFinanceiroId) {
      return 'planoFinTabAtInvest' + planoFinanceiroId
    },

    getKeyPlanoFinDistLucro(planoFinanceiroId) {
      return 'planoFinDistLucro' + planoFinanceiroId
    },

    getKeyPlanoFinTabDistLucro(planoFinanceiroId) {
      return 'planoFinTabDistLucro' + planoFinanceiroId
    },

    getKeyPlanoFinPassivoOperacional(planoFinanceiroId) {
      return 'planoFinPassivoOperacional' + planoFinanceiroId
    },

    getKeyPlanoFinPassivoInvest(planoFinanceiroId) {
      return 'planoFinPassivoInvest' + planoFinanceiroId
    },

    getKeyPlanoFinTabPassivoInvest(planoFinanceiroId) {
      return 'planoFinTabPassivoInvest' + planoFinanceiroId
    },

    getKeyListaEmpresaModalConfig(empresaId) {
      return 'listaEmpresaModalConfig' + empresaId
    },

    getKeyListaEmpresaModal2Config(empresaId) {
      return 'listaEmpresaModal2Config' + empresaId
    },

    getKeyListaEmpresaModal3Config(empresaId) {
      return 'listaEmpresaModal3Config' + empresaId
    },

    getKeyListaContaModalConfig(contaId) {
      return 'listaContaModalConfig' + contaId
    },

    getKeyListaContaModal2Config(contaId) {
      return 'listaContaModal2Config' + contaId
    },

    getKeyListaContaModal3Config(contaId) {
      return 'listaContaModal3Config' + contaId
    },

    getKeyListaPlanFinConfigDRE(planoFinanceiroId) {
      return 'listaPlanFinConfigDRE' + planoFinanceiroId
    },

    getKeyListaConfigContasPagar(planoFinanceiroId) {
      return 'listaConfigContasPagar' + planoFinanceiroId
    },

    retirarCadastroListaOmissaoContasReceber(cadastro_id) {
      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_receber.length; i++) {

        if (this.configuracoes.usuarios_omitir_contas_receber[i].cadastro_id == cadastro_id) {
          this.configuracoes.usuarios_omitir_contas_receber.splice(i, 1)
          this.alterou_cadastros_contas_receber = true
          return
        }

      }
    },

    selecionarCadastroOmitirContasReceber(cadastro) {
      if (!cadastro) {
        return;
      }

      this.mostrar_pesquisa_cadastros = false

      if (!this.configuracoes.usuarios_omitir_contas_receber) {
        this.configuracoes.usuarios_omitir_contas_receber = []
      }

      for (let i = 0; i < this.configuracoes.usuarios_omitir_contas_receber.length; i++) {
        if (this.configuracoes.usuarios_omitir_contas_receber[i].cadastro_id == cadastro.cadastro_id) {
          return;
        }
      }

      this.configuracoes.usuarios_omitir_contas_receber.push(
        {
          cadastro_id: cadastro.cadastro_id,
          cpf_cnpj: cadastro.cpf_cnpj,
          nome_razao_social: cadastro.nome_razao_social
        }
      );

      this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      this.alterou_cadastros_contas_receber = true;
    },

    reprocessarFinanceirosReceber() {
      this.afericao_lucro = {}
      this.gravarConfiguracoesFinanceirosReceber()
      this.buscarDadosAfericaoLucro()
    },

    aplicarConfiguracoesDRE() {
      for (let i = 0; i < this.configuracoes.demonstrativo_fluxo_caixa.length; i++) {
        for (let j = 0; j < this.afericao_lucro.demonstrativo_fluxo_caixa.length; j++) {
          if (this.configuracoes.demonstrativo_fluxo_caixa[i].plano_financeiro_id != this.afericao_lucro.demonstrativo_fluxo_caixa[j].plano_financeiro_id) {
            continue
          }

          this.afericao_lucro.demonstrativo_fluxo_caixa[j].tipo_plano = this.configuracoes.demonstrativo_fluxo_caixa[i].tipo_plano
          break
        }
      }

      this.afericao_lucro.mostrar_titulos_definidos_prejuizo = this.configuracoes.mostrar_titulos_definidos_prejuizo
      this.afericao_lucro.mostrar_perca_estoque = this.configuracoes.mostrar_perca_estoque

      this.afericao_lucro.prejuizo = []

      for (let i = 0; i < this.afericao_lucro.demonstrativo_resultado.length; i++) {
        /* Cheques devolvidos */
        if (this.afericao_lucro.demonstrativo_resultado[i].plano_financeiro_id == 'X.001') {
          if (this.afericao_lucro.mostrar_titulos_definidos_prejuizo) {
            let plano_financeiro = JSON.parse(JSON.stringify(this.afericao_lucro.demonstrativo_resultado[i]))
            plano_financeiro.nome_plano_financeiro = 'CHEQUES DEVOLVIDOS'
            
            this.afericao_lucro.prejuizo.push(plano_financeiro)
          }
        }

        /* Perdas de estoque */
        if (this.afericao_lucro.demonstrativo_resultado[i].plano_financeiro_id == 'X.004') {
          if (this.afericao_lucro.mostrar_perca_estoque) {
            let plano_financeiro = JSON.parse(JSON.stringify(this.afericao_lucro.demonstrativo_resultado[i]))
            plano_financeiro.nome_plano_financeiro = 'PERDAS DE ESTOQUE'
            
            this.afericao_lucro.prejuizo.push(plano_financeiro)
          }
        }
      }

      this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
      this.renderizarResultado()

      return true
    },

    aplicarConfiguracoesContasPagar() {
      for (let i = 0; i < this.configuracoes.financeiros_pagar.length; i++) {
        for (let j = 0; j < this.afericao_lucro.financeiros_pagar.length; j++) {
          if (this.configuracoes.financeiros_pagar[i].plano_financeiro_id != this.afericao_lucro.financeiros_pagar[j].plano_financeiro_id) {
            continue
          }

          this.afericao_lucro.financeiros_pagar[j].tipo_plano = this.configuracoes.financeiros_pagar[i].tipo_plano
          break
        }
      }

      this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
      this.renderizarResultado()

      return true
    },

    gravarConfiguracoesDRE() {
      if (this.aplicarConfiguracoesDRE()) {
        if (this.gravarConfiguracoesUsuario()) {
          this.fecharModalConfiguracoesDRE()
        }
      }
    },

    gravarConfiguracoesContasPagar() {
      if (this.aplicarConfiguracoesContasPagar()) {
        if (this.gravarConfiguracoesUsuario()) {
          this.fecharModalConfiguracoesContasPagar()
        }
      }
    },

    stringToDate(dataStr) {
      let partes = dataStr.split('-')
      let retorno = new Date(partes[0], partes[1] - 1, partes[2])
      return retorno
    },

    stringToDateBr(dataStr) {
      let partes = dataStr.split('/')
      let retorno = new Date(partes[2], partes[1] - 1, partes[0])
      return retorno
    },

    dateToString(data) {
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return ano + '-' + mes + '-' + dia
    },

    dateToStringBR(data) {
      let dia = data.getDate().toString().padStart(2, '0')
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return dia + '/' + mes + '/' + ano
    },

    dateTimeToStringBR(data) {
      let data_str = this.dateToStringBR(data).toString().padStart(2, '0')
      let horas = data.getHours().toString().padStart(2, '0')
      let minutos = data.getMinutes().toString().padStart(2, '0')
      let segundos = data.getSeconds().toString().padStart(2, '0')

      return data_str + ' ' + horas + ':' + minutos + ':' + segundos
    },

    dateToStringMesAnoBR(data) {
      let mes = (data.getMonth() + 1).toString().padStart(2, '0')
      let ano = data.getFullYear()
      return mes + '/' + ano
    },

    async buscarTodasEmpresas() {
      try {
        this.todas_empresas = [];
        this.configuracoes.empresas = [];

        let retorno = await REmpresa.buscarTodasEmpresas(this.axios);
        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.todas_empresas = JSON.parse(JSON.stringify(retorno.dados));
        for (let i = 0;i < this.todas_empresas.length; i++) {
          this.todas_empresas[i].selecionada = true;
          this.configuracoes.empresas.push(this.todas_empresas[i]);
        }
      }
      catch(e) { 
        toastr.error('Não foi possível carregar as empresas! ' + e.message);
      }
    },

    async buscarDadosAfericaoLucro() {
      try {
        if (this.nenhumaEmpresaSelecionada()) {
          throw new Error('Selecione pelo menos uma empresa!');
        }

        if (!this.verificarDadosConfiguracoes(true)) {
          return;
        }

        this.processando = true;

        this.afericao_lucro = [];
        let par_empresas_ids = [];

        for (let i = 0; i < this.configuracoes.empresas.length; i++) {
          if (this.configuracoes.empresas[i].selecionada) {
            par_empresas_ids.push(this.configuracoes.empresas[i].empresa_id);
          }
        }

        let par_periodo = [
          this.configuracoes.periodo.data_inicial,
          this.configuracoes.periodo.data_final
        ];

        let usuarios_omitir_cadastros_fin_receber_ids = [];
        if (this.configuracoes.usuarios_omitir_financeiros_receber) {
          for (let i = 0; i < this.configuracoes.usuarios_omitir_financeiros_receber.length; i++) {
            usuarios_omitir_cadastros_fin_receber_ids.push(
              this.configuracoes.usuarios_omitir_financeiros_receber[i].cadastro_id
            );
          }
        }

        let parametros = {
          tipo_busca: 'AFE',
          empresas_ids: par_empresas_ids,
          periodo: par_periodo,
          usuarios_omitir_cadastros_fin_receber_ids: usuarios_omitir_cadastros_fin_receber_ids
        }

        let retorno = await RAfericaoLucro.buscarAfericaoLucro2(
          this.axios,
          parametros
        );

        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        this.afericao_lucro = JSON.parse(JSON.stringify(retorno.dados));
        
        localStorage.setItem(
          this.c_afericao_lucro_ultimos_dados,
          JSON.stringify(this.afericao_lucro)
        );

        this.processando = false;
        this.ajustarProcessamentoAfericaoLucro();
      }
      catch(e) {
        this.processando = false;
        toastr.error(e.message);
      }
    },

    ajustarProcessamentoAfericaoLucro() {
      this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))

      /* ********************** ADICIONANDO NOMES DAS EMPRESAS DO INVENTÁRIO ********************** */
      if (this.afericao_lucro.estoque) {
        for (let i = 0; i < this.afericao_lucro.estoque.length; i++) {

          if (this.afericao_lucro.estoque[i].empresa_id) {
            for (let j = 0; j < this.todas_empresas.length; j++) {
              if (this.afericao_lucro.estoque[i].empresa_id != this.todas_empresas[j].empresa_id) {
                continue
              }
              
              this.afericao_lucro.estoque[i].nome_resumido = this.todas_empresas[j].nome_resumido
              break
            }
          }
          else if (this.afericao_lucro.estoque[i].empresa_transferencia_id) {
            for (let j = 0; j < this.todas_empresas.length; j++) {
              if (this.afericao_lucro.estoque[i].empresa_transferencia_id != this.todas_empresas[j].empresa_id) {
                continue
              }
              
              this.afericao_lucro.estoque[i].nome_resumido = this.todas_empresas[j].nome_resumido
              break
            }
          }
        }
      }

      /* ************* AJUSTANDO PLANOS FINANCEIROS DO DEMONSTRATIVO DE FLUXO DE CAIXA ************* */
      if (!this.afericao_lucro.demonstrativo_fluxo_caixa) {
        this.configuracoes.demonstrativo_fluxo_caixa = []
      }
      else {
        if ((this.configuracoes.demonstrativo_fluxo_caixa) && (this.configuracoes.demonstrativo_fluxo_caixa.length > 0)) {

          /* Se já tem uma configuracao prévia */          
          let novas_configuracoes = JSON.parse(JSON.stringify(this.afericao_lucro.demonstrativo_fluxo_caixa))
        
          for (let i = 0; i < novas_configuracoes.length; i++) {
            novas_configuracoes[i].indice = i + 1
            novas_configuracoes[i].tipo_plano = 'NEN'

            for (let j = 0; j < this.configuracoes.demonstrativo_fluxo_caixa.length; j++) {
              if (novas_configuracoes[i].plano_financeiro_id != this.configuracoes.demonstrativo_fluxo_caixa[j].plano_financeiro_id) {
                continue
              }

              /* Renderizando conforme configurações antigas */
              novas_configuracoes[i].tipo_plano = this.configuracoes.demonstrativo_fluxo_caixa[j].tipo_plano
              break
            }
          }

          this.configuracoes.demonstrativo_fluxo_caixa = JSON.parse(JSON.stringify(novas_configuracoes))
        }
        else {
          /* Se não tem nenhum plano financeiro configurado anteriormente */
          this.configuracoes.demonstrativo_fluxo_caixa = JSON.parse(JSON.stringify(this.afericao_lucro.demonstrativo_fluxo_caixa))

          for (let i = 0; i < this.configuracoes.demonstrativo_fluxo_caixa.length; i++) {
            this.configuracoes.demonstrativo_fluxo_caixa[i].indice = i + 1
            this.configuracoes.demonstrativo_fluxo_caixa[i].tipo_plano = 'NEN'
          }
        }
      }

      /* ********************** AJUSTANDO PLANOS FINANCEIROS DE CONTAS A PAGAR ********************** */
      if (!this.afericao_lucro.financeiros_pagar) {
        this.configuracoes.financeiros_pagar = []
      }
      else {
        if ((this.configuracoes.financeiros_pagar) && (this.configuracoes.financeiros_pagar.length > 0)) {

          /* Se já tem uma configuracao prévia */
          let novas_configuracoes = JSON.parse(JSON.stringify(this.afericao_lucro.financeiros_pagar))
        
          for (let i = 0; i < novas_configuracoes.length; i++) {
            novas_configuracoes[i].indice = i + 1
            novas_configuracoes[i].tipo_plano = 'NEN'

            if (!novas_configuracoes[i].plano_financeiro_id) {
              novas_configuracoes[i].nome = 'Sem plano financeiro'
            }

            for (let j = 0; j < this.configuracoes.financeiros_pagar.length; j++) {
              if (novas_configuracoes[i].plano_financeiro_id != this.configuracoes.financeiros_pagar[j].plano_financeiro_id) {
                continue
              }

              /* Renderizando conforme configurações antigas */
              novas_configuracoes[i].tipo_plano = this.configuracoes.financeiros_pagar[j].tipo_plano
              break
            }
          }

          this.configuracoes.financeiros_pagar = JSON.parse(JSON.stringify(novas_configuracoes))
        }
        else {
          /* Se não tem nenhum plano financeiro configurado anteriormente */
          this.configuracoes.financeiros_pagar = JSON.parse(JSON.stringify(this.afericao_lucro.financeiros_pagar))

          for (let i = 0; i < this.configuracoes.financeiros_pagar.length; i++) {
            this.configuracoes.financeiros_pagar[i].indice = i + 1            
            this.configuracoes.financeiros_pagar[i].tipo_plano = 'NEN'
          }
        }
      }


      /* ********************** AJUSTANDO CONTAS CAIXAS/BANCOS/APLICAÇÕES ********************** */
      if (!this.afericao_lucro.contas) {
        this.configuracoes.contas = []
      }
      else {
        if ((this.configuracoes.contas) && (this.configuracoes.contas.length > 0)) {

          /* Se já tem uma configuracao prévia */          
          let novas_configuracoes = JSON.parse(JSON.stringify(this.afericao_lucro.contas))
        
          for (let i = 0; i < novas_configuracoes.length; i++) {
            novas_configuracoes[i].tipo_conta = 'CAI'

            for (let j = 0; j < this.configuracoes.contas.length; j++) {
              if (novas_configuracoes[i].conta_id != this.configuracoes.contas[j].conta_id) {
                continue
              }

              /* Renderizando conforme configurações antigas */
              novas_configuracoes[i].selecionada = this.configuracoes.contas[j].selecionada
              novas_configuracoes[i].tipo_conta = this.configuracoes.contas[j].tipo_conta
              break
            }
          }

          this.configuracoes.contas = JSON.parse(JSON.stringify(novas_configuracoes))
        }
        else {
          /* Se não tem nenhuma conta configurada anteriormente */
          this.configuracoes.contas = JSON.parse(JSON.stringify(this.afericao_lucro.contas))

          for (let i = 0; i < this.configuracoes.contas.length; i++) {
            this.configuracoes.contas[i].selecionada = true
            this.configuracoes.contas[i].tipo_conta = 'CAI'
          }
        }

        for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
          this.afericao_lucro.contas[i].tipo_conta = 'CAI'

          for (let j = 0; j < this.configuracoes.contas.length; j++) {
            if (this.afericao_lucro.contas[i].conta_id != this.configuracoes.contas[j].conta_id) {
              continue
            }

            this.afericao_lucro.contas[i].selecionada = this.configuracoes.contas[j].selecionada
            this.afericao_lucro.contas[i].tipo_conta = this.configuracoes.contas[j].tipo_conta
            break
          }
        }
      }

      this.processando = false
      this.alterou_cadastros_contas_receber = false

      /* ********************** AJUSTANDO AS COLUNAS DO RELATÓRIO **********************  */
      this.colunas = []

      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let variacao_zebra = 1;
        if (i % 2 > 0) {
          variacao_zebra = 2;
        }

        this.colunas.push(
          {
            indice: i,
            titulo: this.afericao_lucro.periodos[i],
            tipo: 'M',
            variacao_zebra: variacao_zebra
          }
        )

        this.colunas.push(
          {
            indice: i,
            titulo: 'Resultado',
            tipo: 'R',
            variacao_zebra: variacao_zebra
          }
        )

        this.colunas.push(
          {
            indice: i,
            titulo: 'A.H.',
            tipo: 'A',
            variacao_zebra: variacao_zebra
          }
        )
      }

      this.renderizarResultado()
    },

    buscarClasseLinha(tipo_linha) {
      let classes = ''

      if (tipo_linha == 'PRI') {
        classes += 'plan-titulo-principal '
      }
      else if (tipo_linha == 'RPA') {
        classes += 'plan-resultado-parcial '
      }
      else if (tipo_linha == 'RFI') {
        classes += 'plan-resultado-final '
      }
      else if (tipo_linha == 'DET') {
        classes += 'plan-detalhe '
      }

      return classes
    },

    buscarClasseCelula(tipo, natureza, tipo_coluna, variacao_zebra) {
      let classes = ''

      if (tipo == 'SUB') {
        if (variacao_zebra == 0) {
          if (natureza == 'ATI') {
            classes += 'plan-subtitulo-0-ativo-fixa '
          }
          else {
            classes += 'plan-subtitulo-0-passivo-fixa '
          }
        }
        else if ((variacao_zebra == 1) || (variacao_zebra == 2)) {
          if (natureza == 'ATI') {
          classes += 'plan-subtitulo-0-ativo '
          }
          else {
            classes += 'plan-subtitulo-0-passivo '
          }
        }
      }
      else if (tipo == 'DAT') {
        if (variacao_zebra == 1) {
          classes += 'plan-cabecalho-datas-1 '
        }
        else {
          classes += 'plan-cabecalho-datas-2 '
        }
      }
      else if (tipo == 'DET') {
        if (!tipo_coluna) {
          classes += 'plan-texto-esquerda '
        }

        if (variacao_zebra == 0) {
          if (natureza = 'ATI') {
            classes += 'plan-detalhe-ativo '
          }
          else {
            classes += 'plan-detalhe-passivo '
          }
        }
      }
      
      if (tipo_coluna == 'A') {
        if ((tipo == 'SUB') || (tipo == 'DET') || (tipo == 'DAT')) {
            classes += 'plan-texto-borda-direita '
        }
      }

      return classes
    },
    
    buscarClasseCelulaColunaFixa(tipo, natureza, tipo_coluna, variacao_zebra) {
      let classes = 'plan-texto-esquerda '

      if (tipo == 'PRI') {
        classes += 'plan-titulo-principal '
      }
      else if (tipo == 'SUB') {
        if (natureza == 'ATI') {
          classes += 'plan-subtitulo-0-ativo-fixa '
        }
        else {
          classes += 'plan-subtitulo-0-passivo-fixa '
        }
      }
      else if (tipo == 'DAT') {
        classes += 'plan-cabecalho-datas-fixa '
      }
      else if (tipo == 'DET') {
        classes += 'plan-detalhe '

        if (natureza == 'ATI') {
          classes += 'plan-detalhe-ativo '
        }
        else {
          classes += 'plan-detalhe-passivo '
        }
      }
      else if (tipo == 'RPA') {
        classes += 'plan-resultado-parcial-fixa '
      }
      else if (tipo == 'RFI') {
        classes += 'plan-resultado-final-fixa '
      }

      return classes
    },

    /*definirEmpresaSelecionada() {*/
    renderizarConfiguracoes() {
      let retorno = true
      for (let j = 0; j < this.configuracoes.empresas.length; j++) {
        retorno = this.configuracoes.empresas[j].selecionada
        if (!retorno) {
          break
        }
      }

      this.configuracoes.todas_empresas_selecionadas = retorno
      this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
    },

    renderizarResultado() {
      this.atualizarPeriodoSelecionado(false)

      this.linhas = []

      if (!this.afericao_lucro) {
        return
      }

      /*  ********************************* MONTANDO DETALHES E TOTALIZADORES ********************************* */
      let contas_caixas_bancos_ativas = this.buscarContasAtivas('CAI')
      let totais_contas_caixas_bancos_ativas = this.buscarTotaisContas(contas_caixas_bancos_ativas)

      let contas_aplicacoes_ativas = this.buscarContasAtivas('APL')
      let totais_contas_aplicacoes_ativas = this.buscarTotaisContas(contas_aplicacoes_ativas)

      let estoque = this.afericao_lucro.estoque
      let totais_estoque = this.buscarTotaisEstoque(estoque)

      let financeiros_receber = this.afericao_lucro.financeiros_receber
      let totais_financeiros_receber = this.buscarTotaisFinanceiroReceber(financeiros_receber)

      let planos_demonstrativo_ati = this.buscarPlanosDemonstrativoSelecionados('ATI')
      let totais_planos_demonstrativo_ati = this.buscarTotaisDemonstrativoFluxoCaixa(planos_demonstrativo_ati)


      let planos_contas_pagar_pao = this.buscarPlanosContasPagarSelecionados('PAO')

      let totais_planos_contas_pagar_pao = this.buscarTotaisDemonstrativoContasPagar(planos_contas_pagar_pao)

      let planos_contas_pagar_pai = this.buscarPlanosContasPagarSelecionados('PAI')
      let totais_planos_contas_pagar_pai = this.buscarTotaisDemonstrativoContasPagar(planos_contas_pagar_pai)

      let planos_demonstrativo_dlu = this.buscarPlanosDemonstrativoSelecionados('DLU')
      let totais_planos_demonstrativo_dlu = this.buscarTotaisDemonstrativoFluxoCaixa(planos_demonstrativo_dlu)

      let total_ativo = this.buscarTotalAtivo(
        totais_contas_caixas_bancos_ativas,
        totais_contas_aplicacoes_ativas,
        totais_estoque,
        totais_financeiros_receber,
        totais_planos_demonstrativo_ati
      )

      let total_passivo = this.buscarTotalPassivo(
        totais_planos_contas_pagar_pao,
        totais_planos_contas_pagar_pai
      )

      let total_operacional = this.buscarTotalOperacional(
        total_ativo,
        total_passivo
      )

      let prejuizos = this.afericao_lucro.prejuizo
      let total_prejuizos = this.buscarTotalPrejuizos(prejuizos)

      let resultado = this.buscarResultado(
        total_operacional,
        total_prejuizos
      )

      /*  *********************************************** ATIVO *********************************************** */
      this.adicionarDatas()
      let valores = this.buscarValoresTotalizadores(total_ativo)
      this.adicionarLinhaTituloPrincipal('ATIVO', valores)

      if (contas_caixas_bancos_ativas.length > 0) {        

        valores = this.buscarValoresContas(totais_contas_caixas_bancos_ativas)
        this.adicionarLinhaSubtitulo('+ CAIXAS / BANCOS', valores, 'ATI')

        for (let i = 0; i < contas_caixas_bancos_ativas.length; i++) {
          valores = this.buscarValoresContas(contas_caixas_bancos_ativas[i].saldos)

          this.adicionarLinhaDetalhe(
            contas_caixas_bancos_ativas[i].conta_id + ' - ' + contas_caixas_bancos_ativas[i].nome_portador + ' (' + contas_caixas_bancos_ativas[i].tipo_analitico + ')', 
            valores, 
            undefined,
            0,
            'ATI'
          )
        }
      }

      if (contas_aplicacoes_ativas.length > 0) {
        this.adicionarDatas()

        valores = this.buscarValoresContas(totais_contas_aplicacoes_ativas)
        this.adicionarLinhaSubtitulo('+ APLICAÇÕES', valores, 'ATI')

        for (let i = 0; i < contas_aplicacoes_ativas.length; i++) {
          valores = this.buscarValoresContas(contas_aplicacoes_ativas[i].saldos)
          this.adicionarLinhaDetalhe(
            contas_aplicacoes_ativas[i].conta_id + ' - ' + contas_aplicacoes_ativas[i].nome_portador + ' (' + contas_aplicacoes_ativas[i].tipo_analitico + ')', 
            valores, 
            undefined,
            0,
            'ATI'
          )
        }
      }

      this.adicionarDatas()
      valores = this.buscarValoresEstoque(totais_estoque)
      this.adicionarLinhaSubtitulo('+ ESTOQUE DISPONÍVEL', valores, 'ATI')

      for (let i = 0; i < estoque.length; i++) {
        valores = this.buscarValoresEstoque(estoque[i].saldos)

        if (estoque[i].empresa_id) {
          this.adicionarLinhaDetalhe(
            nPadrao(estoque[i].empresa_id, 0) + ' - ' + estoque[i].nome_resumido, 
            valores, 
            undefined,
            0,
            'ATI'
          )
        }
        else if (estoque[i].empresa_transferencia_id) {
          this.adicionarLinhaDetalhe(
            'Transferências p/ empresa ' + nPadrao(estoque[i].empresa_transferencia_id, 0) + ' - ' + estoque[i].nome_resumido, 
            valores, 
            undefined,
            0,
            'ATI'
          )
        }
      }

      this.adicionarDatas()
      valores = this.buscarValoresFinanceiroReceber(totais_financeiros_receber)
      this.adicionarLinhaSubtitulo('+ CLIENTES', valores, 'ATI')

      for (let i = 0; i < financeiros_receber.length; i++) {
        valores = this.buscarValoresFinanceiroReceber(financeiros_receber[i].saldos)
        this.adicionarLinhaDetalhe(
          financeiros_receber[i].tipo_analitico, 
          valores,
          undefined,
          0,
          'ATI'
        )
      }
      
      if (planos_demonstrativo_ati.length > 0) {
        this.adicionarDatas()
        
        valores = this.buscarValoresDemonstrativoFluxoCaixa(totais_planos_demonstrativo_ati)
        this.adicionarLinhaSubtitulo('+ INVESTIMENTOS', valores, 'ATI')

        for (let i = 0; i < planos_demonstrativo_ati.length; i++) {
          valores = this.buscarValoresDemonstrativoFluxoCaixa(planos_demonstrativo_ati[i].saldos)
          this.adicionarLinhaDetalhe(
            planos_demonstrativo_ati[i].plano_financeiro_id + ' - ' + planos_demonstrativo_ati[i].nome_plano_financeiro,
            valores,
            undefined,
            0,
            'ATI'
          )
        }
      }

      /*  *********************************************** PASSIVO *********************************************** */
      this.adicionarDatas()
      valores = this.buscarValoresTotalizadores(total_passivo)
      this.adicionarLinhaTituloPrincipal('PASSIVO', valores)

      if (planos_contas_pagar_pao.length > 0) {
        valores = this.buscarValoresDemonstrativoContasPagar(totais_planos_contas_pagar_pao)
        this.adicionarLinhaSubtitulo('- PASSIVO OPERACIONAL', valores, 'PAS')

        for (let i = 0; i < planos_contas_pagar_pao.length; i++) {
          valores = this.buscarValoresDemonstrativoContasPagar(planos_contas_pagar_pao[i].saldos)
          this.adicionarLinhaDetalhe(
            this.descricaoPlanoFinanceiro(planos_contas_pagar_pao[i]),
            valores,
            undefined,
            0,
            'PAS'
          )
        }
      }
      
      if (planos_contas_pagar_pai.length > 0) {
        this.adicionarDatas()

        valores = this.buscarValoresDemonstrativoContasPagar(totais_planos_contas_pagar_pai)
        this.adicionarLinhaSubtitulo('- DIVIDAS COM INVESTIMENTO', valores, 'PAS')

        for (let i = 0; i < planos_contas_pagar_pai.length; i++) {
          valores = this.buscarValoresDemonstrativoContasPagar(planos_contas_pagar_pai[i].saldos)
          this.adicionarLinhaDetalhe(
            this.descricaoPlanoFinanceiro(planos_contas_pagar_pai[i]),
            valores,
            undefined,
            0,
            'PAS'
          )
        }
      }

      /*  *********************************************** SÓCIOS *********************************************** */
      if (planos_demonstrativo_dlu.length > 0) {
        this.adicionarDatas()

        valores = this.buscarValoresDemonstrativoFluxoCaixa(totais_planos_demonstrativo_dlu)
        this.adicionarLinhaSubtitulo('+ SÓCIOS', valores, 'ATI')

        for (let i = 0; i < planos_demonstrativo_dlu.length; i++) {
          valores = this.buscarValoresDemonstrativoFluxoCaixa(planos_demonstrativo_dlu[i].saldos)
          this.adicionarLinhaDetalhe(
            planos_demonstrativo_dlu[i].plano_financeiro_id + ' - ' + planos_demonstrativo_dlu[i].nome_plano_financeiro,
            valores,
            undefined,
            0,
            'ATI'
          )
        }
      }

      /*  *************************************** RESULTADO OPERACIONAL *************************************** */
      this.adicionarDatas()

      valores = this.buscarValoresTotalizadores(total_operacional)
      this.adicionarLinhaResultadoParcial('RESULTADO OPERACIONAL', valores)


      /*  ********************************************** PREJUIZO ********************************************** */
      if ((prejuizos) && (prejuizos.length > 0)) {
        valores = this.buscarValoresTotalizadores(total_prejuizos)
        this.adicionarLinhaSubtitulo('- PREJUÍZO', valores, 'PAS')

        for (let i = 0; i < prejuizos.length; i++) {
          valores = this.buscarValoresDemonstrativoResultado(prejuizos[i].saldos)
          this.adicionarLinhaDetalhe(
            prejuizos[i].nome_plano_financeiro,
            valores,
            undefined,
            0,
            'PAS'
          )
        }
      }

      valores = this.buscarValoresTotalizadores(resultado)
      this.adicionarLinhaResultadoFinal('RESULTADO', valores)


      let celula = 0

      for (let i = 0; i < this.linhas.length; i++) {
        this.linhas[i].indice = i

        this.linhas[i].coluna_fixa.indice = celula
        celula += 1

        for (let j = 0; j < this.linhas[i].celulas.length; j++) {
          this.linhas[i].celulas[j].indice = celula
          celula += 1
        }
      }

      this.ajustarPaginacoes()

      if (this.mostrar_coluna_fixa) {
        $(document).ready(function() {
          $('#grid table').css('margin-left', $('.lateral-fixa').width())
        });
      }
      else {
        $('#grid table').css('margin-left', '0')
      }

    },

    mudarColunaFixa() {
      this.renderizarResultado()
    },

    buscarContasAtivas(tipo_conta) {
      if ((!this.afericao_lucro) || (!this.afericao_lucro.contas)) {
        return []
      }

      let retorno = []

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (!this.afericao_lucro.contas[i].selecionada) {
          continue
        }

        if (this.afericao_lucro.contas[i].tipo_conta != tipo_conta) {
          continue
        }

        retorno.push(
          JSON.parse(JSON.stringify(this.afericao_lucro.contas[i]))
        )
      }

      return retorno
    },

    buscarValoresContas(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarTotaisEstoque(estoque) {
      let retorno = []

      if ((!estoque) || (estoque.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i].periodo,
          saldo: 0
        }

        for (let j = 0; j < estoque.length; j++) {
          objeto_retorno.saldo += parseFloat(estoque[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarTotaisContas(contas_ativas) {
      let retorno = []

      if ((!contas_ativas) || (contas_ativas.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i].periodo,
          saldo: 0
        }

        for (let j = 0; j < contas_ativas.length; j++) {
          objeto_retorno.saldo += parseFloat(contas_ativas[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarValoresTotaisContas() {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresTotalizadores(totais) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < totais.length; i++) {
        retorno.push(nPadraoTraco(totais[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {
          let resultado_ah = this.calcularPercentualAnaliseHorizontal(totais[i-1].saldo, totais[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresEstoque(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresDemonstrativoContasPagar(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresDemonstrativoFluxoCaixa(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresDemonstrativoResultado(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarValoresFinanceiroReceber(saldos) {
      let retorno = []

      let resultado = 0
      let ah = 0

      for (let i = 0; i < saldos.length; i++) {
        retorno.push(nPadraoTraco(saldos[i].saldo, 2))
        
        /* Calculando */
        if (i > 0) {

          let resultado_ah = this.calcularPercentualAnaliseHorizontal(saldos[i-1].saldo, saldos[i].saldo)
          resultado = resultado_ah.resultado
          ah = resultado_ah.percentual
        }

        /* Formatando */
        resultado = nPadraoTraco(resultado, 2)

        if ((ah) && (nPadrao(ah, 2) != nPadrao(0, 2))) {
          ah = nPadraoTraco(ah, 2) + '%'
        }
        else {
          ah = nPadraoTraco(ah, 2)
        }

        retorno.push(resultado)
        retorno.push(ah)
      }

      return retorno
    },

    buscarTotaisFinanceiroReceber(financeiros_receber) {
      let retorno = []

      if ((!financeiros_receber) || (financeiros_receber.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i].periodo,
          saldo: 0
        }

        for (let j = 0; j < financeiros_receber.length; j++) {
          objeto_retorno.saldo += parseFloat(financeiros_receber[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarPlanosDemonstrativoSelecionados(tipo_plano) {
      let retorno = []

      if ((!this.afericao_lucro.demonstrativo_fluxo_caixa) || (this.afericao_lucro.demonstrativo_fluxo_caixa.length == 0)) {
        return retorno
      }
      
      for (let j = 0; j < this.afericao_lucro.demonstrativo_fluxo_caixa.length; j++) {
        if (this.afericao_lucro.demonstrativo_fluxo_caixa[j].tipo_plano == tipo_plano) {
          retorno.push(JSON.parse(JSON.stringify(this.afericao_lucro.demonstrativo_fluxo_caixa[j])))
        }
      }      

      return retorno
    },

    buscarPlanosContasPagarSelecionados(tipo_plano) {
      let retorno = []

      if ((!this.afericao_lucro.financeiros_pagar) || (this.afericao_lucro.financeiros_pagar.length == 0)) {
        return retorno
      }
      
      for (let j = 0; j < this.afericao_lucro.financeiros_pagar.length; j++) {
        if (this.afericao_lucro.financeiros_pagar[j].tipo_plano == tipo_plano) {
          retorno.push(JSON.parse(JSON.stringify(this.afericao_lucro.financeiros_pagar[j])))
        }
      }      

      return retorno
    },

    buscarTotalAtivo(
      totais_contas_caixas_bancos_ativas,
      totais_contas_aplicacoes_ativas,
      totais_estoque,
      totais_financeiros_receber,
      totais_planos_demonstrativo_ati
    ) {
      let retorno = []

      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        /* Inicializando */
        retorno.push(
          {
            periodo: this.afericao_lucro.periodos[i],
            saldo: 0
          }
        )
      }

      for (let i = 0; i < retorno.length; i++) {
        if (totais_contas_caixas_bancos_ativas && totais_contas_caixas_bancos_ativas.length > i) {
          retorno[i].saldo += totais_contas_caixas_bancos_ativas[i].saldo
        }

        if (totais_contas_aplicacoes_ativas && totais_contas_aplicacoes_ativas.length > i) {
          retorno[i].saldo += totais_contas_aplicacoes_ativas[i].saldo
        }

        if (totais_estoque && totais_estoque.length > i) {
          retorno[i].saldo += totais_estoque[i].saldo
        }

        if (totais_financeiros_receber && totais_financeiros_receber.length > i) {
          retorno[i].saldo += totais_financeiros_receber[i].saldo
        }

        if (totais_planos_demonstrativo_ati && totais_planos_demonstrativo_ati.length > i) {
          retorno[i].saldo += totais_planos_demonstrativo_ati[i].saldo
        }
      }

      return retorno
    },

    buscarTotalPassivo(totais_planos_contas_pagar_pao, totais_planos_contas_pagar_pai) {
      let retorno = []

      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        /* Inicializando */
        retorno.push(
          {
            periodo: this.afericao_lucro.periodos[i],
            saldo: 0
          }
        )
      }

      for (let i = 0; i < retorno.length; i++) {
        if (totais_planos_contas_pagar_pao && totais_planos_contas_pagar_pao.length > i) {
          retorno[i].saldo += totais_planos_contas_pagar_pao[i].saldo
        }

        if (totais_planos_contas_pagar_pai && totais_planos_contas_pagar_pai.length > i) {
          retorno[i].saldo += totais_planos_contas_pagar_pai[i].saldo
        }
      }

      return retorno
    },

    buscarTotalOperacional(total_ativo, total_passivo) {
      let retorno = []

      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        /* Inicializando */
        retorno.push(
          {
            periodo: this.afericao_lucro.periodos[i],
            saldo: 0
          }
        )
      }

      for (let i = 0; i < retorno.length; i++) {
        if (total_ativo && total_ativo.length > i) {
          retorno[i].saldo += total_ativo[i].saldo
        }

        if (total_passivo && total_passivo.length > i) {
          retorno[i].saldo -= total_passivo[i].saldo
        }
      }

      return retorno
    },

    buscarTotalPrejuizos(prejuizos) {
      let retorno = []

      if ((!prejuizos) || (prejuizos.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i],
          saldo: 0
        }

        for (let j = 0; j < prejuizos.length; j++) {
          objeto_retorno.saldo += parseFloat(prejuizos[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarResultado(total_operacional, total_prejuizos) {
      let retorno = []

      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i],
          saldo: 0
        }

        if (total_operacional && total_operacional.length > 0) {
          objeto_retorno.saldo += parseFloat(total_operacional[i].saldo)
        }

        if (total_prejuizos && total_prejuizos.length > 0) {
          objeto_retorno.saldo -= parseFloat(total_prejuizos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarTotaisDemonstrativoFluxoCaixa(planos_demonstrativo) {
      let retorno = []

      if ((!planos_demonstrativo) || (planos_demonstrativo.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i].periodo,
          saldo: 0
        }

        for (let j = 0; j < planos_demonstrativo.length; j++) {
          objeto_retorno.saldo += parseFloat(planos_demonstrativo[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    buscarTotaisDemonstrativoContasPagar(planos_contas_pagar) {
      let retorno = []

      if ((!planos_contas_pagar) || (planos_contas_pagar.length == 0)) {
        return retorno
      }
      
      for (let i = 0; i < this.afericao_lucro.periodos.length; i++) {
        let objeto_retorno = {
          periodo: this.afericao_lucro.periodos[i].periodo,
          saldo: 0
        }

        for (let j = 0; j < planos_contas_pagar.length; j++) {
          objeto_retorno.saldo += parseFloat(planos_contas_pagar[j].saldos[i].saldo)
        }

        retorno.push(objeto_retorno)
      }

      return retorno
    },

    adicionarLinhaResultadoParcial(titulo, valores) {
      let linha = {
        tipo: 'RPA',
        natureza: 'ATI',
        coluna_fixa: {
          texto: titulo,
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < valores.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: valores[i],
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: 0
          }
        )
      }
      
      this.linhas.push(linha)
    },

    adicionarLinhaResultadoFinal(titulo, valores) {
      let linha = {
        tipo: 'RFI',
        natureza: 'ATI',
        coluna_fixa: {
          texto: 'RESULTADO',
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < valores.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: valores[i],
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: 0
          }
        )
      }

      this.linhas.push(linha)
    },

    adicionarLinhaTituloPrincipal(titulo, valores) {
      let linha = {
        tipo: 'PRI',
        coluna_fixa: {
          texto: titulo,
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < valores.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: valores[i],
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: 0
          }
        )
      }
      
      this.linhas.push(linha)
    },

    adicionarDatas() {
      let linha = {
        tipo: 'DAT',
        coluna_fixa: {
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < this.colunas.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: this.colunas[i].titulo,
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: this.colunas[i].variacao_zebra
          }
        )
      }

      this.linhas.push(linha)
    },

    adicionarLinhaSubtitulo(subtitulo, valores, natureza) {
      let linha = {
        tipo: 'SUB',
        natureza: natureza,
        coluna_fixa: {
          texto: subtitulo,
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < valores.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: valores[i],
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: this.colunas[i].variacao_zebra
          }
        )
      }

      this.linhas.push(linha)
    },

    adicionarLinhaDetalhe(descricao, valores, tipo_coluna, variacao_zebra, natureza) {
      let linha = {
        tipo: 'DET',
        natureza: natureza,
        coluna_fixa: {
          texto: descricao,
          variacao_zebra: 0
        },
        celulas: []
      }

      for (let i = 0; i < valores.length; i++) {
        linha.celulas.push(
          {
            colspan: 1,
            texto: valores[i],
            tipo_coluna: this.colunas[i].tipo,
            variacao_zebra: this.colunas[i].variacao_zebra
          }
        )
      }

      this.linhas.push(linha)
    },

    calcularPercentualAnaliseHorizontal(total_periodo_1, total_periodo_2) {
      let saldo_1 = Number(total_periodo_1)
      let saldo_2 = Number(total_periodo_2)

      let resultado = saldo_2 - saldo_1

      let percentual = 0
      if (
        nPadrao(saldo_1, 2) != nPadrao(saldo_2, 2) &&
        nPadrao(saldo_1, 2) != nPadrao(0, 2)
      ) {
        percentual = (resultado / saldo_1) * 100
        
        if (percentual < 0) {
          percentual = percentual * -1
        }

        if (saldo_2 < saldo_1) {
          percentual = percentual * -1
        }
      }

      let retorno = {
        resultado: resultado,
        percentual: percentual
      }

      return retorno
    },

    adicionarTotalizacaoFinanceiro(periodo, tipo_financeiro, total_geral) {
      for (let i = 0; i < this.resumo_financeiros.length; i++) {
        if (this.resumo_financeiros[i].tipo_sintetico != tipo_financeiro) {
          continue
        }

        if (periodo == 1) {
          this.resumo_financeiros[i].total_periodo_1 = total_geral
        } else {
          this.resumo_financeiros[i].total_periodo_2 = total_geral
        }

        break
      }
    },

    nenhumaEmpresaSelecionada() {
      if (!this.configuracoes) {
        return true
      }

      if (!this.configuracoes.empresas) {
        return true
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        if (this.configuracoes.empresas[i].selecionada) {
          return false
        }
      }

      return true
    },

    todasEmpresasSelecionadas() {
      if (!this.configuracoes) {
        return false
      }

      if (!this.configuracoes.empresas) {
        return false
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        if (!this.configuracoes.empresas[i].selecionada) {
          return false
        }
      }

      return true
    },

    selecionarTodasEmpresas() {
      if (!this.configuracoes) {
        return
      }

      if (!this.configuracoes.empresas) {
        return
      }

      for (let i = 0; i < this.configuracoes.empresas.length; i++) {
        this.configuracoes.empresas[i].selecionada = true
      }

      this.configuracoes.empresas = JSON.parse(JSON.stringify(this.configuracoes.empresas))
    },

    nenhumaContaSelecionada() {
      if (!this.afericao_lucro) {
        return true
      }

      if (!this.afericao_lucro.contas) {
        return true
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (this.afericao_lucro.contas[i].selecionada) {
          return false
        }
      }

      return true
    },

    todasContasSelecionadas() {
      if (!this.afericao_lucro) {
        return false
      }

      if (!this.afericao_lucro.contas) {
        return false
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (!this.afericao_lucro.contas[i].selecionada) {
          return false
        }
      }

      return true
    },

    selecionarTodasContas() {
      if (!this.configuracoes) {
        return
      }

      if (!this.configuracoes.contas) {
        return
      }

      for (let i = 0; i < this.configuracoes.contas.length; i++) {
        this.configuracoes.contas[i].selecionada = true
      }

      this.configuracoes = JSON. parse(JSON.stringify(this.configuracoes))      
    },

    aplicarConfiguracoesContas() {
      let temContaSelecionada = false

      for (let i = 0; i < this.configuracoes.contas.length; i++) {
        if (this.configuracoes.contas[i].selecionada) {
          temContaSelecionada = true
          break
        }
      }

      if (!temContaSelecionada) {
        toastr.error('Selecione pelo menos uma conta!')
        return false
      }

      for (let i = 0; i < this.configuracoes.contas.length; i++) {
        for (let j = 0; j < this.afericao_lucro.contas.length; j++) {
          if (this.configuracoes.contas[i].conta_id != this.afericao_lucro.contas[j].conta_id) {
            continue
          }

          this.afericao_lucro.contas[j].selecionada = this.configuracoes.contas[i].selecionada
          this.afericao_lucro.contas[j].tipo_conta = this.configuracoes.contas[i].tipo_conta
          
          break
        }
      }

      this.afericao_lucro = JSON.parse(JSON.stringify(this.afericao_lucro))
      this.renderizarResultado()

      return true
    },

    async gravarConfiguracoesUsuario(descricao, tipo_configuracao, salvo_automaticamente) {
      try {
        this.processando_modal_dados_salvos = true;

        if (!tipo_configuracao) {
          tipo_configuracao = 'CON';
        }

        let chave = this.c_afericao_lucro_ultimos_dados;
        let configuracao = this.afericao_lucro;
        let mensagem = 'Dados processados gravados com sucesso.';

        if (tipo_configuracao == 'CON') {
          chave = this.c_afericao_lucro_configuracoes;
          configuracao = this.configuracoes;
          mensagem = 'Configurações gravadas com sucesso.';
        }

        localStorage.setItem(chave, JSON.stringify(configuracao));

        if (!descricao) {
          if (tipo_configuracao == 'CON') {        
            descricao = 'configuracao_afericao_lucro_' + this.dateTimeToStringBR(new Date());
          }
          else {
            descricao = 'afericao_lucro_' + this.dateTimeToStringBR(new Date());
          }
        }

        if (!salvo_automaticamente) {
          salvo_automaticamente = 'S';
        }

        descricao = descricao.replace('/', '').replace('/', '');
        descricao = descricao.replace(' ', '_').replace(' ', '_').replace(' ', '_');
        descricao = descricao.replace(':', '').replace(':', '');

        let parametros = {
          operacao: 'ADI',
          chave: chave,
          descricao: descricao,
          salvo_automaticamente: salvo_automaticamente,
          configuracao: configuracao
        }

        let retorno = await RConfiguracaoUsuarioADMWeb.gravarConfiguracao(
          this.axios,
          parametros
        );
        
        this.nome_salvar = '';

        if (retorno.houve_erro != 'N') {
          throw new Error('Não foi possível gravar as configurações! ' + retorno.mensagem);
        }
        
        if (salvo_automaticamente != 'S') {
          toastr.info('Operação realizada com sucesso.');
        }

        this.processando_modal_dados_salvos = false;
        return true;
      }
      catch(e) {
        toastr.error(e.message);
        return false;
      }
    },

    excluirConfiguracoesAutomaticas() {
      let vetor = []
      let vetor_dados = []

      if (this.tipo_configuracao == 'CON') {
        vetor_dados = this.configuracoes_salvas
      }
      else {
        vetor_dados = this.processamentos_salvos
      }

      for (let i = 0; i < vetor_dados.length; i++) {
        if (vetor_dados[i].salvo_automaticamente != 'S') {
          continue
        }

        vetor.push(vetor_dados[i].configuracao_usuario_id)
      }

      if (vetor.length > 0) {
        this.excluirconfiguracoes(vetor)
      }
      else {
        toastr.info('Nenhum item se enquadra neste tipo de exclusão.')
        return false
      }
    },

    excluirTodasConfiguracoes() {
      let vetor = []
      let vetor_dados = []
      if (this.tipo_configuracao == 'CON') {
        vetor_dados = this.configuracoes_salvas
      }
      else {
        vetor_dados = this.processamentos_salvos
      }

      if ((!vetor_dados) || (vetor_dados.length == 0)) {
        return
      }

      for (let i = 0; i < vetor_dados.length; i++) {
        vetor.push(vetor_dados[i].configuracao_usuario_id)
      }

      if (vetor.length > 0) {
        this.excluirconfiguracoes(vetor)
      }
      else {
        toastr.info('Nenhum item se enquadra neste tipo de exclusão.')
        return false
      }
    },

    excluirConfiguracaoSalva(configuracao_usuario_id) {
      let vetor = []
      vetor.push(configuracao_usuario_id)
      this.excluirconfiguracoes(vetor)
    },

    async excluirconfiguracoes(configuracoes_usuarios_ids) {
      try {
        this.processando_modal_dados_salvos = true
        
        let parametros = {
          configuracoes_usuarios_ids: configuracoes_usuarios_ids
        }

        let retorno = await RConfiguracaoUsuarioADMWeb.excluirConfiguracao(
          this.axios,
          parametros
        );

        if (retorno.houve_erro != 'N') {
          throw new Error(retorno.mensagem);
        }

        let mensagem = 'Configurações excluidas com sucesso.'
        if (configuracoes_usuarios_ids.length == 1) {
          mensagem = 'Configuração excluida com sucesso.'
        }
        toastr.info(mensagem)
        this.atualizarListaConfiguracoesADMWeb(false, this.tipo_configuracao);
        this.processando_modal_dados_salvos = false;

        return true;
      }
      catch(e) {
        this.processando_modal_dados_salvos = false;
        toastr.error(e.message);
      }
    },

    buscarElementoContaSmall(conta_id) {
      return 'contaSmall' + conta_id
    },

    buscarElementoContaLarge(conta_id) {
      return 'contaLarge' + conta_id
    },

    buscarElementoPlanoFinanceiro(planoFinanceiroId, complemento) {
      return 'planoFinanceiro' + planoFinanceiroId + complemento
    },

    buscarElementoContaPagar(planoFinanceiroId, complemento) {
      return 'contaPagar' + planoFinanceiroId + complemento
    },

    buscarElementoEmpresa(empresa_id) {
      return 'empresa' + empresa_id
    },

    nPadraoPercentual: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let texto = nPadrao(val, casas_decimais);
      if (texto == '') {
        texto = ''
      } else {
        texto = '(' + texto + '%)'
      }

      return texto
    },

    nPadraoTraco: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let texto = nPadrao(val, casas_decimais);
      if (texto == '') {
        texto = ''
      } else if (texto == nPadrao('0.00', casas_decimais)) {
        texto = '--'
      }

      return texto
    },

    nPadrao: function(val, casas_decimais) {
      if (!val) {
        return ''
      }

      let valor = Math.abs(val).toFixed(casas_decimais);
      let sinal = ''
      if (val < -0.001) {
        sinal = '-'
      }

      if (!valor) {
        return nPadrao(0, casas_decimais)
      }

      let numero

      if (casas_decimais == 0) {
        let formato = { minimumFractionDigits: casas_decimais };
        numero = parseInt(valor)
        return numero.toLocaleString('pt-BR', formato)
      } else {
        if (valor.length - casas_decimais - 1 >= 0 && valor.charAt(valor.length - casas_decimais - 1) == ',') {
          numero = parseFloat(valor.replace(',', '.'))
        } else {
          numero = parseFloat(valor)
        }

        numero = numero.toFixed(casas_decimais).split('.')
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.')

        return sinal + numero.join(',')
      }
    },

    totalizarTipoPlanoFinanceiro(tipo_plano) {
      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      //////////////////////////// RETURN PROVISÓRIO ////////////////////////////
      return retorno

      if (!this.afericao_lucro) {
        return retorno
      }

      if (this.configuracoes.planos_financeiros) {
        for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
          for (let j = 0; j < this.configuracoes.planos_financeiros.length; j++) {
            if (
              this.afericao_lucro.planos_financeiros[i].plano_financeiro_id !=
              this.configuracoes.planos_financeiros[j].plano_financeiro_id
            ) {
              continue
            }

            if (this.configuracoes.planos_financeiros[j].tipo_plano == tipo_plano) {
              retorno.total_periodo_1 += parseFloat(this.afericao_lucro.planos_financeiros[i].total_periodo_1)
              retorno.total_periodo_2 += parseFloat(this.afericao_lucro.planos_financeiros[i].total_periodo_2)
            }
          }
        }
      }

      let analise_vertical = this.calcularPercentualAnaliseHorizontal(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_vertical.resultado
      retorno.percentual = analise_vertical.percentual

      if ((tipo_plano == 'ATI') || (tipo_plano == 'DLU')) {
        retorno.total_periodo_1 = 0
        retorno.resultado = retorno.total_periodo_2
        retorno.percentual = 100
      }

      return retorno
    },

    totalizarPassivoOperacional() {
      if (!this.afericao_lucro) {
        return null
      }

      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      };

      //////////////////////////// RETURN PROVISÓRIO ////////////////////////////
      return retorno

      for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
        if (this.afericao_lucro.financeiros_pagar[i].selecionado != plano) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(
          this.afericao_lucro.financeiros_pagar[i].total_periodo_1
        )

        retorno.total_periodo_2 += parseFloat(
          this.afericao_lucro.financeiros_pagar[i].total_periodo_2
        )
      }

      let analise_horizontal = this.calcularPercentualAnaliseHorizontal(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_horizontal.resultado
      retorno.percentual = analise_horizontal.percentual

      return retorno
    },

    totalizarContasPagar(plano) {
      if (!this.afericao_lucro) {
        return null;
      }

      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      //////////////////////////// RETURN PROVISÓRIO ////////////////////////////
      return retorno;

      for (let i = 0; i < this.afericao_lucro.financeiros_pagar.length; i++) {
        if (this.afericao_lucro.financeiros_pagar[i].selecionado != plano) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(this.afericao_lucro.financeiros_pagar[i].total_periodo_1)
        retorno.total_periodo_2 += parseFloat(this.afericao_lucro.financeiros_pagar[i].total_periodo_2)
      }

      let analise_horizontal = this.calcularPercentualAnaliseHorizontal(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_horizontal.resultado
      retorno.percentual = analise_horizontal.percentual

      return retorno
    },

    totalizarContas(tipo_conta) {
      let retorno = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      if (!this.afericao_lucro) {
        return retorno
      }

      //////////////////////////// RETORNO PROVISÓRIO ////////////////////////////
      return retorno

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {
        if (!this.afericao_lucro.contas[i].selecionada) {
          continue
        }

        if (this.afericao_lucro.contas[i].tipo_conta != tipo_conta) {
          continue
        }

        retorno.total_periodo_1 += parseFloat(this.afericao_lucro.contas[i].total_periodo_1)
        retorno.total_periodo_2 += parseFloat(this.afericao_lucro.contas[i].total_periodo_2)
      }

      let analise_horizontal = this.calcularPercentualAnaliseHorizontal(
        retorno.total_periodo_1,
        retorno.total_periodo_2
      )

      retorno.resultado = analise_horizontal.resultado
      retorno.percentual = analise_horizontal.percentual

      return retorno
    },

    totalizarAtivo() {
      let total_ativo = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      //////////////////////////// RETURN PROVISÓRIO ////////////////////////////
      return total_ativo;

      if (!this.afericao_lucro) {
        return total_ativo
      }

      let planos_ativo = this.totalizarTipoPlanoFinanceiro('ATI')
      let contas_caixa = this.totalizarContas('CAI')
      let contas_aplicacoes = this.totalizarContas('APL')

      total_ativo = {
        total_periodo_1:
          parseFloat(contas_caixa.total_periodo_1) +
          parseFloat(contas_aplicacoes.total_periodo_1) +
          parseFloat(this.afericao_lucro.totais_financeiros_receber.total_periodo_1) +
          parseFloat(this.afericao_lucro.totais_inventarios.total_periodo_1) +
          parseFloat(planos_ativo.total_periodo_1),

        total_periodo_2:
          parseFloat(contas_caixa.total_periodo_2) +
          parseFloat(contas_aplicacoes.total_periodo_2) +
          parseFloat(this.afericao_lucro.totais_financeiros_receber.total_periodo_2) +
          parseFloat(this.afericao_lucro.totais_inventarios.total_periodo_2) +
          parseFloat(planos_ativo.total_periodo_2)
      }

      let analise_horizontal = this.calcularPercentualAnaliseHorizontal(
        total_ativo.total_periodo_1,
        total_ativo.total_periodo_2
      )

      total_ativo.resultado = analise_horizontal.resultado
      total_ativo.percentual = analise_horizontal.percentual

      return total_ativo
    },

    totalizarPassivo() {
      if (!this.afericao_lucro) {
        return null
      }

      let passivo_op = this.totalizarContasPagar('PAO')
      let passivo_inv = this.totalizarContasPagar('PAI')

      let balanco_passivo = {
        total_periodo_1:
          parseFloat(passivo_op.total_periodo_1) +
          parseFloat(passivo_inv.total_periodo_1),

        total_periodo_2:
          parseFloat(passivo_op.total_periodo_2) +
          parseFloat(passivo_inv.total_periodo_2)
      }

      let analise_horizontal = this.calcularPercentualAnaliseHorizontal(
        balanco_passivo.total_periodo_1,
        balanco_passivo.total_periodo_2
      )

      balanco_passivo.resultado = analise_horizontal.resultado
      balanco_passivo.percentual = analise_horizontal.percentual

      return balanco_passivo
    },
  
    async gerarPlanilha(){
      try {
        this.mostrar_planilha = false;
        if (this.mostrar_coluna_fixa){
          this.mostrar_coluna_fixa =  false
          toastr.info("Não gerar com coluna fixa habilitada, tente novamente.")
          return
        }
        /* Obs variaves no componente de geração tem que ser tipo var */
        let data = new Date();
        let dia  = data.getDate().toString();
        let diaF = (dia.length == 1) ? '0'+dia : dia;
        let mes  = (data.getMonth()+1).toString(); //+1 pois no getMonth Janeiro começa com zero.
        let mesF = (mes.length == 1) ? '0'+mes : mes;
        let anoF = data.getFullYear();
        let hora = data.getHours();
        let minutos =  data.getMinutes();
      
        var inicio_cabecalho = {
              rowIndex: 4
        }; /* 4 linhas vazias no início*/
        var tabela = document.querySelector("#dados-tabela");
        var planilha = XLSX2.utils.table_to_sheet(tabela, inicio_cabecalho);
        
        /*var planilha = XLSX2.utils.json_to_sheet(this.linhas); para pegar uma matriz de objetos json com dados brutos*/
        /*cabeçalho*/
        planilha["C2"] = {
          t: "s",
          v: 'AFERIÇÃO DE LUCRO'
        }; /*Atribuir valor à célula c2 da planilha*/
        planilha["C2"].s = { 
          font: {
              name: 'aferição de lucro',
              sz: 24,
              bold: true,
              underline: false,
              color: {
                rgb: "4d4dff"
              }
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrap_text: true
            },
            
        };
        
        planilha["B1"] = {
          t: "s",
          v: "Data geração: "+ diaF+"/"+mesF+"/"+anoF + " - " + hora + ":" + minutos
        }; //Atribuir valor à célula B2
        
        planilha["B1"].s = {
          font: {
            sz: 8,
            bold: true,
            underline: false,
            color: {
              rgb: "94b8b8"
            }
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
            wrap_text: true
          },
        };
        
        let empresas_geradas = []
        for(let i in this.configuracoes.empresas){
          empresas_geradas.push(" "+this.configuracoes.empresas[i].nome_resumido)
        }
        planilha["A3"] = {
          t: "s",
          v: "Empresas: "+ empresas_geradas
        }; 
        
        /* laços para colocar style*/
        for(let j in planilha){
            if(planilha[j].v == "ATIVO" || planilha[j].v == "PASSIVO"){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :"ffffff"}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "000000"}
                },
              };
            };
            if(planilha[j].v == "+ CAIXAS / BANCOS" || 
              planilha[j].v == "+ ESTOQUE DISPONÍVEL" ||
              planilha[j].v == "+ CLIENTES" || 
              planilha[j].v == "+ INVESTIMENTOS" ||
              planilha[j].v == "+ SÓCIOS"
              ){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :'ffffff'}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "22610e"}
                },
              };
            };
            if(planilha[j].v == "RESULTADO OPERACIONAL"){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :'ffffff'}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "a8b2ee"}
                },
              };
            };
            if(planilha[j].v == "RESULTADO"){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :'ffffff'}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "044F81"}
                },
              };
            };
            if(planilha[j].v == "- DIVIDAS COM INVESTIMENTO" || planilha[j].v == "- PASSIVO OPERACIONAL" || planilha[j].v == "- PREJUÍZO"){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :'ffffff'}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "61110e"}
                },
              };
            };
          
            if(planilha[j].v == "Resultado" && planilha[j].v != "+ CAIXAS / BANCOS" || planilha[j].v == "A.H."){
              planilha[j].s =  { //estilo esndereço da celula
                font: {
                  sz: 16,
                  patternType : 'solid',
                  bold: true,
                  color :{ rgb :"000000"}
                },
                alignment: {
                  horizontal: "left",
                  vertical: "center",
                  wrap_text: true
                },
                fill: {
                  patternType : 'solid',
                  fgColor: {rgb: "dddddd"},
                }
              };
            };
          }
        
        /*Largura da coluna da célula*/
        let largura_colunas= [];
        for(let k = 0;k < this.colunas.length; k++){
          if(k == 0){
            largura_colunas.push({wpx: 400})
          }else{
            largura_colunas.push({wpx: 150})
          }
        }
        planilha["!cols"] = largura_colunas;
      
        this.ver_planilha = planilha
        /* função chamada do componente para baixar a planilha*/
        await openDownloadDialog(sheet2blob(planilha, 'Aferição de lucro'), 'Aferição_de_lucro.xlsx');
        this.mostrar_planilha = true;
      } catch (error) {
        toastr.info("Não foi possível gerar a planilha.")
        this.mostrar_planilha = true;
      }
        
    },
    criarGrafico(indice, mais, anterior, titulo) {
      this.titulo_grafico = titulo;
    
      if(anterior){
        this.mais_posicao -= mais;
      }else{
        this.mais_posicao += mais;
      }
      /*ajustando o limite para -1 do grafico (paginação)*/
      if(this.mais_posicao < 0 ){
        this.mais_posicao += mais;
        toastr.info("Não existe dados a serem mostrados.")
        return
      }
      /* tratamento limite de caso minimo (paginação)*/
      if(this.colunas.length == 6){
        this.mais_posicao -= mais;
      }
      
      /* tratando limite de limite fim primeiro caso (paginação)*/
      if(this.mais_posicao > this.colunas.length){
          this.mais_posicao -= mais;
          toastr.info("Não existe dados a serem mostrados.")
          return
      }
      
      /* definindo o limite do fim do grafico (paginação)*/
      let fim = this.colunas.length - this.mais_posicao;
      if(this.colunas.length > 8){
        if(fim < 9){
          this.mais_posicao -= mais;
          toastr.info("Não existe dados a serem mostrados.")
          return
        }
      }
    
      this.indice_atual = indice;
      let cores_grafico = [];
      let valores = [];
      let categorias = [];
      let i = this.mais_posicao;
      
      /* pegando a legendas de datas no pé de cada coluna do grafico*/
      let contador = 0;
      for(i; i < this.colunas.length; i++){
        if(this.colunas[i].tipo == "M" ){
          if(contador < 4){
            categorias.push(this.colunas[i].titulo);
          }
          contador++;
        }
      }
      
      /* pegar ativo com operacional*/
      let ativos = [];
      for(let linha in this.linhas){
        if(this.linhas[linha].coluna_fixa.texto == "ATIVO"){
          for(let celula in this.linhas[linha].celulas){
            ativos.push(Biblioteca.valor(this.linhas[linha].celulas[celula].texto));
          }
        }
      }
      
      /* pegar passivo com operacional*/
      let passivo = [];
      for(let linha in this.linhas){
        if(this.linhas[linha].coluna_fixa.texto == "PASSIVO"){
          for(let celula in this.linhas[linha].celulas){
            passivo.push(Biblioteca.valor(this.linhas[linha].celulas[celula].texto));
          }
        }
      }
      
      /* ajustando dados e cores do grafico quando é um grafico agrupado ou não*/
      contador = 0;
      let x = this.mais_posicao;
      let grafico_multiplo = false;
      let cor_passivo = false;
      for(x; x <  this.linhas[this.indice_atual].celulas.length; x++){
        if(this.linhas[this.indice_atual].celulas[x].tipo_coluna == "M"){
          if(contador < 4){
            if(this.linhas[this.indice_atual].coluna_fixa.texto == "RESULTADO OPERACIONAL"){
              valores.push(Biblioteca.valor(this.linhas[this.indice_atual].celulas[x].texto));
              cores_grafico.push('#a8b2ee');
              valores.push(ativos[x]);
              cores_grafico.push('#0fdbac');
              valores.push(passivo[x]);
              cores_grafico.push('#db0f49');
              grafico_multiplo = true;
              console.log(this.linhas[this.indice_atual].coluna_fixa.natureza)
            }else{
              valores.push(Biblioteca.valor(this.linhas[this.indice_atual].celulas[x].texto));
              if( this.linhas[this.indice_atual].coluna_fixa.texto == "PASSIVO" || 
                this.linhas[this.indice_atual].coluna_fixa.texto == "- PASSIVO OPERACIONAL" || 
                this.linhas[this.indice_atual].coluna_fixa.texto == "- DIVIDAS COM INVESTIMENTO" ||
                this.linhas[this.indice_atual].natureza == "PAS"

                )
                {
                  cores_grafico.push('#db0f49');
                  cor_passivo = true;
                }
            }
          }
          contador++;
        }
      }
      
      /* ajustando cores no caso de grafico simples*/
      if(!grafico_multiplo){
        for(let i in valores){
          if(valores[i] < 0){
            if(!cor_passivo){
              cores_grafico.push('#db0f49');
            }
          }else{
            cores_grafico.push('#0fdbac');
          }
        }
      }
      
      this.series = [{
        name: 'Valor',
        data: valores
      }],
    

      this.chartOptions = {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },

        colors: cores_grafico,
        
        dataLabels: {
          enabled: true,   
          offsetY: 0,
          offsetX: 0,
          formatter: function (val) {
            return "R$ "+ nPadrao(val,2)
          },
        },

        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: true,
                position: 'bottom',
                offsetX: 10,
                offsetY: 0
              }
            }
          }
        ],

        plotOptions: {
          bar: {
            horizontal: false,
            distributed: true,
          },
        },
        
        legend: {
          show: true,
          position: 'center',
          offsetY: 30
        },

        fill: {
          opacity: 1
        },

        title: {
          text: this.titulo_grafico,
          align: 'center',
          margin: 10,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize:  '20px',
            fontWeight:  'bold',
            fontFamily:  undefined,
            color:  '#9c1d1c', 
            margin: '10px'
          },
        },

        xaxis: {            
          categories:  categorias,  
        },

        yaxis: {
          show: false,
          enabled: false,
          title: {
            text: undefined
          },
        },

        tooltip: {
          position: 'center',
          categories: categorias,
          y: {
            formatter: function(val){
              return "R$ "+ nPadrao(val, 2)
            }
          }
        },
      
        fill: {
          opacity: 1
        },

        legend: {
         
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }       
      }

      this.mostrar_grafico = true
    },
    
    baixarPlanilhaResultado() {
      toastr.error('A planilha não está desenvolvida ainda.');
    },

    getPlanosTipo: function(tipo) {
      let retorno = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.planos_financeiros)) {
        return retorno
      }

      for (let i = 0; i < this.afericao_lucro.planos_financeiros.length; i++) {
        if (this.afericao_lucro.planos_financeiros[i].tipo_plano != tipo) {
          continue
        }

        retorno.push(JSON.parse(JSON.stringify(this.afericao_lucro.planos_financeiros[i])))
      }

      if ((tipo == 'ATI') || (tipo == 'DLU')) {
        for (let i = 0; i < retorno.length; i++) {
          retorno[i].total_periodo_1 = 0
          retorno[i].resultado = retorno[i].total_periodo_2
          retorno[i].percentual = 100
        }
      }

      return retorno 
    },

    getMovimentosPrejuizo: function() {
      let prejuizos_mostrar = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.prejuizos)) {
        return prejuizos_mostrar
      }

      if (this.configuracoes.mostrar_titulos_definidos_prejuizo) {

        for (let i = 0; i < this.afericao_lucro.prejuizos.length; i++) {
        
          if (this.afericao_lucro.prejuizos[i].tipo == 'CDE') {
            prejuizos_mostrar.push(
              {
                tipo: 'CDE',
                descricao: 'Cheques devolvidos',
                total_periodo_1: 0,
                total_periodo_2: this.afericao_lucro.prejuizos[i].total_periodo_2,
                resultado: this.afericao_lucro.prejuizos[i].total_periodo_2,
                percentual: 100
              }
            )
          }

        }
      }


      if (this.configuracoes.mostrar_perca_estoque) { 
        for (let i = 0; i < this.afericao_lucro.prejuizos.length; i++) {
          if (this.afericao_lucro.prejuizos[i].tipo == 'PES') {
            prejuizos_mostrar.push(
              {
                tipo: 'PES',
                descricao: 'Perdas de estoque',
                total_periodo_1: 0,
                total_periodo_2: this.afericao_lucro.prejuizos[i].total_periodo_2,
                resultado: this.afericao_lucro.prejuizos[i].total_periodo_2,
                percentual: 100
              }
            )
          }

        }
      }

      return prejuizos_mostrar
    },

    getContasSelecionadas() {
      let contas_selecionadas = []

      if ((!this.afericao_lucro) || (!this.afericao_lucro.contas)) {
        return contas_selecionadas
      }

      for (let i = 0; i < this.afericao_lucro.contas.length; i++) {      
        if (!this.afericao_lucro.contas[i].selecionada) {
          continue
        }

        contas_selecionadas.push(JSON.parse(JSON.stringify(this.afericao_lucro.contas[i])))
      }

      return contas_selecionadas
    },

    getContasTipoSelecionado(tipo_conta) {
      let contas_tipo = []
      let contas_selecionadas = this.getContasSelecionadas()
      for (let i = 0; i < contas_selecionadas.length; i++) {      
        if (contas_selecionadas[i].tipo_conta != tipo_conta) {
          continue
        }

        contas_tipo.push(JSON.parse(JSON.stringify(contas_selecionadas[i])))
      }

      return contas_tipo
    },

    getCorColuna(cor) {
      return 'background-color: ' + cor + '; '
    },

    atualizarPeriodoSelecionado(mostrar_excecao) {
      this.configuracoes.periodo.periodo_selecionado = 'Período indefinido'

      if (!this.configuracoes.periodo.data_inicial || !this.configuracoes.periodo.data_final) {
        if (mostrar_excecao) {
          toastr.error('Informe um período válido!')
        }

        return false
      }

      let dt1 = this.stringToDateBr('01/' + this.configuracoes.periodo.data_inicial)
      let dt2 = this.stringToDateBr('01/' + this.configuracoes.periodo.data_final)

      if (this.dateToStringMesAnoBR(dt1) != this.configuracoes.periodo.data_inicial) {
        if (mostrar_excecao) {
          toastr.error('Data inicial inválida!')
        }

        return false
      }

      if (this.dateToStringMesAnoBR(dt2) != this.configuracoes.periodo.data_final) {
        if (mostrar_excecao) {
          toastr.error('Data final inválida!')
        }

        return false
      }

      if (dt1 > dt2) {
        if (mostrar_excecao) {
          toastr.error('A data inicial não pode ser maior que a data final!')
        }

        return false
      }

      this.configuracoes.periodo.periodo_selecionado = this.dateToStringMesAnoBR(dt1) + ' a ' + this.dateToStringMesAnoBR(dt2)

      return true
    },
  },

  created() {
    this.buscarTodasEmpresas();
    
    /* Data inicial */
    let x_data_inicial = new Date();
    x_data_inicial.setDate(1);
    x_data_inicial.setMonth(0);
    x_data_inicial.setFullYear(x_data_inicial.getFullYear() - 1);

    let x_data_final = new Date();
    x_data_final.setDate(31);
    x_data_final.setMonth(11);
    x_data_final.setFullYear(x_data_final.getFullYear() - 1);

    this.configuracoes.periodo.data_inicial = this.dateToStringMesAnoBR(x_data_inicial);
    this.configuracoes.periodo.data_final = this.dateToStringMesAnoBR(x_data_final);

    this.atualizarPeriodoSelecionado(false);
  },

  computed: {
    temResultado() {
      return this.getLinhasRenderizadas.length > 0
    },

    getLinhasRenderizadas() {
      if (!this.linhas) {
        return []
      }
      else {
        return this.linhas
      }
    },

    getTotaisPlanosAtivoInvestimento: function() {
      return this.totalizarTipoPlanoFinanceiro('ATI')
    },

    getPlanosTipoAtivoInvestimento: function() {
      return this.getPlanosTipo('ATI')
    },

    getContasAplicacaoSelecionadas: function() {
      return this.getContasTipoSelecionado('APL')
    },

    getPlanosTipoDistribuicaoLucro: function() {
      return this.getPlanosTipo('DLU')
    },

    getTotaisPassivoOperacional: function() {
      return this.totalizarContasPagar('PAO');
    },

    getTotaisPlanosPassivoInvestimento: function() {
      return this.totalizarContasPagar('PAI')
    },

    getTotaisBalancoAtivo: function() {
      return this.totalizarAtivo()
    },

    getTotaisContasCaixasBancos: function() {
      return this.totalizarContas('CAI')
    },

    getTotaisContasAplicacoes: function() {
      return this.totalizarContas('APL')
    },

    getTotaisBalancoPassivo: function() {
      return this.totalizarPassivo()
    },

    getTotaisBalancoDistribuicaoLucro: function() {
      return this.totalizarTipoPlanoFinanceiro('DLU')
    },

    getTotaisPrejuizo: function() {
      let movimentos_prejuizo = this.getMovimentosPrejuizo()

      let obj = {
        total_periodo_1: 0,
        total_periodo_2: 0,
        resultado: 0,
        percentual: 0
      }

      for (let i = 0; i < movimentos_prejuizo.length; i++) {
        obj.total_periodo_1 += parseFloat(movimentos_prejuizo[i].total_periodo_1)
        obj.total_periodo_2 += parseFloat(movimentos_prejuizo[i].total_periodo_2)
      }

      let analise_vertical = this.calcularPercentualAnaliseHorizontal(
        obj.total_periodo_1,
        obj.total_periodo_2
      )

      obj.resultado = analise_vertical.resultado
      obj.percentual = analise_vertical.percentual

      return obj
    }
  }
}


</script>


<style scoped>
  /* ///////////////////////////////// Estilo de linhas e células ///////////////////////////////// */
  .plan-titulo-principal {
    background-color: #000000; 
    color: #ffffff;
    font-weight: bold;
  }

  .plan-resultado-parcial-fixa {
    background-color: #a8b2ee; 
    color: #000000;
    font-weight: bold;
  }

  .plan-resultado-parcial {
    background-color: #c4caee; 
    color: #000000;
    font-weight: bold;
  }

  .plan-resultado-final-fixa {
    background-color: #044F81; 
    color: #ffffff;
    font-weight: bold;
  }

  .plan-resultado-final {
    background-color: rgb(32, 95, 138); 
    color: #ffffff;
    font-weight: bold;
  }

  .plan-cabecalho-datas-fixa {
    color: none;
    border: none;
  }

  .plan-cabecalho-datas-1 {
    background-color: #dddddd; 
    color: #000000;
    font-weight: bold;
    border-top: 1px solid #000000;
  }

  .plan-cabecalho-datas-2 {
    background-color: #ededed; 
    color: #000000;
    font-weight: bold;
    border-top: 1px solid #000000;
  }

  .plan-subtitulo-0-ativo-fixa {
    background-color: #22610e; 
    color: #ffffff;
    font-weight: bold;
    width: 100%;
    padding-left: 5px !important;
  }

  .plan-subtitulo-0-ativo {
    background-color: #387525; 
    color: #ffffff;
    font-weight: bold;
    padding-left: 5px !important;
  }

  .plan-subtitulo-0-passivo-fixa {
    background-color: #61110e; 
    color: #ffffff;
    font-weight: bold;
    padding-left: 5px !important;
  }

  .plan-subtitulo-0-passivo {
    background-color: #722927; 
    color: #ffffff;
    font-weight: bold;
    padding-left: 5px !important;
  }

  .plan-subtitulo-1 {
    background-color: #dddddd; 
    color: #000000;
    font-weight: bold;
  }

  .plan-subtitulo-2 {
    background-color: #ededed; 
    color: #000000;
    font-weight: bold;
  }

  .plan-texto-esquerda {
    text-align: left !important;
    padding-left: 5px !important;
  }

  .plan-texto-borda-direita {
    border-right: 1px dotted #999999;
  }

  .plan-detalhe {
    border-bottom: 1px dotted #999999;
    font-size: 12px;
  }

  .plan-detalhe-ativo {
    background-color: #d4f1de;
  }

  .plan-detalhe-passivo {
    background-color: #eedcda;
  }


  /* ///////////////////////////////// Estilo do grid (scroll) ///////////////////////////////// */
.lateral-fixa {
  position: absolute;
  border: 1px solid #000000 !important;
  top:0;
}


.lateral-fixa div {
  line-height: 45px;
  height: 45px;
}

  #grid {
    overflow: hidden;
    position: relative;
  }

  #grid thead td {
    position: sticky;
    top: 0;
  }


  #grid thead td {
    z-index: 0;
    position: fixed;
  }

  #grid table {
    border-top: none;
    border-collapse: collapse;
  }

  #grid td,
  #grid th {
    padding: 0.5em;
  }

.table-container{
  overflow: scroll;
}

  /* ///////////////////////////////// Outras classes e CSS a serem validadas ///////////////////////////////// */

.link {
  cursor: pointer !important;
  font-weight: bold;
}

.checkbox-group strong {
  cursor: pointer;
}

.switch-input {
  display: none;
}

.switch-label {
  position: relative;
  display: inline-block;
  min-width: 112px;
  cursor: pointer;
  text-align: left;
  padding: 10px 0 10px 44px;
}

.switch-label:before,
.switch-label:after {
  content: '';
  position: absolute;
  margin: 0;
  outline: 0;
  top: 50%;
  -ms-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}

.switch-label:before {
  left: 1px;
  width: 34px;
  height: 14px;
  background-color: #9e9e9e;
  border-radius: 8px;
}

.switch-label:after {
  left: 0;
  width: 20px;
  height: 20px;
  background-color: #fafafa;
  border-radius: 50%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14),
    0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
}

.switch-label .toggle--on {
  display: none;
}

.switch-label .toggle--off {
  display: inline-block;
}

.switch-input:checked + .switch-label:before {
  background-color: #34acfe;
}

.switch-input:checked + .switch-label:after {
  background-color: #0080d6;
  -ms-transform: translate(80%, -50%);
  -webkit-transform: translate(80%, -50%);
  transform: translate(80%, -50%);
}

.lista-leitura-simples {
  display: inline-block;
  margin: 0;
  padding: 0;
  list-style: none;
}

.lista-leitura-simples li {
  display: inline-block;
  margin: 2px;
  padding: 2px 6px 2px 6px;
}

.lista-leitura {
  margin: 0;
  padding: 0;
  list-style: none;
}

.lista-leitura li {
  display: inline-block;
  border: 1px solid #888888;
  border-radius: 5px;
  margin: 2px;
  padding: 2px 6px 2px 6px;
  font-weight: 500;
  border-left: 7px solid #af1a1a;
  box-shadow: 0px 0px 7px #00000050;
}

.tabela-resultado {
  border: 1px solid #999999;
  width: 1000px!important;
  text-align: right;
  word-wrap:break-word;
  white-space: nowrap;
}

.cor-enfase {
  background-color: #90ee90;
}

.cor-enfase-2 {
  background-color: #e0ffff;
}

.cor-enfase-final {
  background-color: #044f81;
  color: #ffffff;
}

.cor-verde {
  color: #31b404;
}

.cor-vermelha {
  color: #af1a1a;
}

.link-vermelho {
  color: #af1a1a;
  text-decoration: underline;
  cursor: pointer;
}

.sublinhado {
  text-decoration: underline;
}

.borda-pontilhada-base {
  border-bottom: 1px dotted #666666;
}

.borda-pontilhada-topo {
  border-top: 1px dotted #666666;
}

.cor-enfase th {
  padding: 8px;
}

.linha-enfase {
  background-color: #dddddd;
}

.linha-enfase-principal {
  background-color: #000000;
}

.linha-enfase-principal strong {
  color: #ffffff;
}
.margin-top10{
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/AfericaoLucro2.vue